import { dateComparator } from '../../../ui-components/ag-gird-table/__helpers__/functions';

export const RECORD_2_TABLE_HEADERS = [
   {
      field: 'fareTariffNumber',
      headerName: 'TAR',
      headerTooltip: 'Fare Tariff Number',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'carrier_code',
      headerName: 'CXR',
      headerTooltip: 'Carrier Code',
   },
   {
      field: 'footnoteCode',
      headerName: 'FT',
      headerTooltip: 'Footnote Code',
   },
   {
      field: 'categoryNumber',
      headerName: 'CAT#',
      headerTooltip: 'Category Number',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'sequenceNumber',
      headerName: 'SEQUENCE',
      headerTooltip: 'Sequence Number',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'effectiveDateString',
      headerName: 'EFF DT',
      headerTooltip: 'Effective Date',
      comparator: dateComparator,
   },
   {
      field: 'discontinueDateString',
      headerName: 'DISC DT',
      headerTooltip: 'Discontinue Date',
   },
   {
      field: 'location1Type',
      headerName: 'LOC1 TYPE',
      headerTooltip: 'Location 1 Type',
   },
   {
      field: 'location1Code',
      headerName: 'LOC1',
      headerTooltip: 'Location 1',
   },
   {
      field: 'location2Type',
      headerName: 'LOC2 TYPE',
      headerTooltip: 'Location 2 Type',
   },
   {
      field: 'location2Code',
      headerName: 'LOC2',
      headerTooltip: 'Location 2',
   },
   {
      field: 'fareClassCode',
      headerName: 'FBC',
      headerTooltip: 'Fare Class Code',
   },
   {
      field: 'roundTripIndicator',
      headerName: 'OWRT',
      headerTooltip: 'OW/RT Indicator',
   },
   {
      field: 'routingNumber',
      headerName: 'RTG',
      headerTooltip: 'Routing',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'applicationInd',
      headerName: 'NOTAPPL',
      headerTooltip: 'Application Indicator',
   },
   {
      field: 'jointCarrier997Id',
      headerName: 'JT CXR TBL',
      headerTooltip: 'Joint Carrier 997 ID',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'segmentCount',
      headerName: 'SEGS',
      headerTooltip: 'Segment Count',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'actionCode',
      headerName: 'ACT',
      headerTooltip: 'Action Code',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'batchCode',
      headerName: 'BATCH',
      headerTooltip: 'Batch',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
   {
      field: 'product_type',
      headerName: 'FT TYPE',
      headerTooltip: 'Footnote Type',
   },
];
export const RULES_RECORD_2_TABLE_HEADERS = [
   {
      field: 'ruleTariffNumber',
      headerName: 'TAR',
      headerTooltip: 'Rule Tariff Number',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'carrier_code',
      headerName: 'CXR',
      headerTooltip: 'Carrier Code',
   },
   {
      field: 'categoryNumber',
      headerName: 'CAT#',
      headerTooltip: 'Category Number',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'sequenceNumber',
      headerName: 'SEQUENCE',
      headerTooltip: 'Sequence Number',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'ruleNumber',
      headerName: 'RULE',
      headerTooltip: 'Rule Number',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'effectiveDateString',
      headerName: 'EFF DT',
      headerTooltip: 'Effective Date',
      comparator: dateComparator,
   },
   {
      field: 'discontinueDateString',
      headerName: 'DISC DT',
      headerTooltip: 'Discontinue Date',
   },
   {
      field: 'location1Type',
      headerName: 'LOC1 TYPE',
      headerTooltip: 'Location 1 Type',
   },
   {
      field: 'location1Code',
      headerName: 'LOC1',
      headerTooltip: 'Location 1',
   },
   {
      field: 'location2Type',
      headerName: 'LOC2 TYPE',
      headerTooltip: 'Location 2 Type',
   },
   {
      field: 'location2Code',
      headerName: 'LOC2',
      headerTooltip: 'Location 2',
   },
   {
      field: 'fareClassCode',
      headerName: 'FBC',
      headerTooltip: 'Fare Class Code',
   },
   {
      field: 'footnoteCode',
      headerName: 'FT',
      headerTooltip: 'Footnote Code',
   },
   {
      field: 'roundTripIndicator',
      headerName: 'OWRT',
      headerTooltip: 'OW/RT Indicator',
   },
   {
      field: 'routingNumber',
      headerName: 'RTG',
      headerTooltip: 'Routing',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'dayOfWeekType',
      headerName: 'DOWT',
      headerTooltip: 'Day of Week Type Code',
   },
   {
      field: 'fareType',
      headerName: 'TYP',
      headerTooltip: 'Fare Type Code',
   },
   {
      field: 'seasonType',
      headerName: 'ST',
      headerTooltip: 'Season Type Code',
   },
   {
      field: 'generalRuleInd',
      headerName: 'GENRULE',
      headerTooltip: 'General Rule Application',
   },
   {
      field: 'generalRuleNumber',
      headerName: 'GRN',
      headerTooltip: 'General Rule Number',
   },
   {
      field: 'generalRuleTariffNumber',
      headerName: 'GRT',
      headerTooltip: 'General Rule Tariff',
   },
   {
      field: 'applicationInd',
      headerName: 'NOTAPPL',
      headerTooltip: 'Application Indicator',
   },
   {
      field: 'jointCarrier997Id',
      headerName: 'JT CXR TBL',
      headerTooltip: 'Joint Carrier 997 ID',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'segmentCount',
      headerName: 'SEGS',
      headerTooltip: 'Segment Count',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'actionCode',
      headerName: 'ACT',
      headerTooltip: 'Action Code',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'batchCode',
      headerName: 'BATCH',
      headerTooltip: 'Batch',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
   {
      field: 'product_type',
      headerName: 'R TYPE',
      headerTooltip: 'Rule Type',
   },
];

export const SEGMENTS_TABLE_HEADERS = [
   {
      field: 'relationalInd',
      headerName: 'REL',
      headerTooltip: 'Relational Indicator',
      width: 64,
   },
   {
      field: 'inOutboundInd',
      headerName: 'IO',
      headerTooltip: 'Inbound/Outbound Indicator',
      width: 60,
   },
   {
      field: 'directionalInd',
      headerName: 'DIR',
      headerTooltip: 'Directional Indicator',
      width: 64,
   },
   {
      field: 'categoryNumber',
      headerName: 'CAT#',
      headerTooltip: 'Category Number',
      width: 76,
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'record3TableId',
      headerName: 'REC3ID',
      headerTooltip: 'Rec3 Table ID',
      width: 92,
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'segmentNumber',
      headerName: 'SEG',
      headerTooltip: 'Segment Number',
      width: 64,
      cellStyle: { textAlign: 'left' },
   },
];

export const CATEGORY_14_TABLE_HEADERS = [
   {
      field: 'commenceFromDate',
      headerName: 'TVL ST',
      headerTooltip: 'Travel Start Date',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'commenceToDate',
      headerName: 'TVL END',
      headerTooltip: 'Travel End Date',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'completeDate',
      headerName: 'TVL CMPLT',
      headerTooltip: 'Travel Complete Date',
   },
   {
      field: 'completeInd',
      headerName: 'RI',
      headerTooltip: 'Return Ind',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'geographic995Id',
      headerName: 'GEO 995',
      headerTooltip: 'Geographic 995 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'geo995LocationType',
      headerName: 'LOCTYP 995',
      headerTooltip: 'Geo Location Type',
   },
   {
      field: 'geo995Location1Code',
      headerName: 'LOC1 995',
      headerTooltip: 'Geo Loc1 Code',
   },
   {
      field: 'geo995Location2Code',
      headerName: 'LOC2 995',
      headerTooltip: 'Geo Loc2 Code',
   },
   {
      field: 'geo995TravelSegmentIndicator',
      headerName: 'TSI 995',
      headerTooltip: 'Geo 995 TSI Ind',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'timeOfDay',
      headerName: 'RET TM',
      headerTooltip: 'Return Time Of Day',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
];

export const CATEGORY_15_TABLE_HEADERS = [
   {
      field: 'ticketingFromDate',
      headerName: 'FST TKT',
      headerTooltip: 'First Ticketing Date',
   },
   {
      field: 'ticketingToDate',
      headerName: 'LST TKT',
      headerTooltip: 'Last Ticketing Date',
   },
   {
      field: 'reservationFromDate',
      headerName: 'FST RES',
      headerTooltip: 'First Reservation Date',
   },
   {
      field: 'reservationToDate',
      headerName: 'LST RES',
      headerTooltip: 'Last Reservation Date',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'salesSegmentListLocationTypeCode',
      headerName: 'LOCTYP',
      headerTooltip: 'Location Type',
   },
   {
      field: 'salesSegmentListLocation1Code',
      headerName: 'LOC1',
      headerTooltip: 'Location 1',
   },
   {
      field: 'salesSegmentListLocation2Code',
      headerName: 'LOC2',
      headerTooltip: 'Location 2',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
];

export const CATEGORY_3_TABLE_HEADERS = [
   {
      field: 'overrideInd',
      headerName: 'OVR IND',
      headerTooltip: 'Override Ind',
   },
   {
      field: 'seasonTypeCode',
      headerName: 'SEA TYP',
      headerTooltip: 'Season Type Code',
   },
   {
      field: 'startDate',
      headerName: 'SEA ST',
      headerTooltip: 'Season Start Date',
   },
   {
      field: 'stopDate',
      headerName: 'SEA END',
      headerTooltip: 'Season End Date',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date',
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'geographic995Id',
      headerName: 'GEO 995',
      headerTooltip: 'Geographic 995 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'geo995LocationType',
      headerName: 'LOCTYP 995',
      headerTooltip: 'Geo Location Type',
   },
   {
      field: 'geo995Location1Code',
      headerName: 'LOC1 995',
      headerTooltip: 'Geo Loc1 Code',
   },
   {
      field: 'geo995Location2Code',
      headerName: 'LOC2 995',
      headerTooltip: 'Geo Loc2 Code',
   },
   {
      field: 'geo995TravelSegmentIndicator',
      headerName: 'TSI 995',
      headerTooltip: 'Geo 995 TSI Ind',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
];

export const CATEGORY_11_TABLE_HEADERS = [
   {
      field: 'applicationInd',
      headerName: 'APP IND',
      headerTooltip: 'Application Ind',
   },
   {
      field: 'intConnectionInd',
      headerName: 'INT CON WV',
      headerTooltip: 'International Conn Waiver',
   },
   {
      field: 'startDate',
      headerName: 'BLACKOUT ST',
      headerTooltip: 'Blackout Start Date',
   },
   {
      field: 'stopDate',
      headerName: 'BLACKOUT END',
      headerTooltip: 'Blackout End Date',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'andTable995Id',
      headerName: 'AND GEO 995',
      headerTooltip: 'And Geographic 995 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'and995LocationType',
      headerName: 'AND LOCTYP 995',
      headerTooltip: 'And Geo Location Type',
   },
   {
      field: 'and995Location1Code',
      headerName: 'AND LOC1 995',
      headerTooltip: 'And Geo Loc1 Code',
   },
   {
      field: 'and995Location2Code',
      headerName: 'AND LOC2 995',
      headerTooltip: 'And Geo Loc2 Code',
   },
   {
      field: 'and995TravelSegmentIndicator',
      headerName: 'AND TSI 995',
      headerTooltip: 'And Geo TSI Ind',
   },
   {
      field: 'betweenTable995Id',
      headerName: 'BET GEO 995',
      headerTooltip: 'Between Geographic 995 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'between995LocationType',
      headerName: 'BET LOCTYP 995',
      headerTooltip: 'Between Geo Location Type',
   },
   {
      field: 'between995Location1Code',
      headerName: 'BET LOC1 995',
      headerTooltip: 'Between Geo Loc1 Code',
   },
   {
      field: 'between995Location2Code',
      headerName: 'BET LOC2 995',
      headerTooltip: 'Between Geo Loc2 Code',
   },
   {
      field: 'between995TravelSegmentIndicator',
      headerName: 'BET TSI 995',
      headerTooltip: 'Between Geo TSI Ind',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
];
export const CATEGORY_01_TABLE_HEADERS = [
   {
      field: 'passengerTypeCode',
      headerName: 'PTC',
      headerTooltip: 'Passenger Type Code',
   },
   {
      field: 'maximumAge',
      headerName: 'MAX AGE',
      headerTooltip: 'Maximum Age',
   },
   {
      field: 'minimumAge',
      headerName: 'MIN AGE',
      headerTooltip: 'Minimum Age',
   },
   {
      field: 'passengerStatusCode',
      headerName: 'PSC',
      headerTooltip: 'Passenger Status Code',
   },
   {
      field: 'accountCode',
      headerName: 'AC',
      headerTooltip: 'Account Code',
   },
   {
      field: 'applicationInd',
      headerName: 'APP IND',
      headerTooltip: 'Application Ind',
   },
   {
      field: 'firstOccurrence',
      headerName: 'FIRST OCC',
      headerTooltip: 'First Occurrence',
   },
   {
      field: 'lastOccurrence',
      headerName: 'LAST OCC',
      headerTooltip: 'Last Occurrence',
   },
   {
      field: 'idRequirementInd',
      headerName: 'ID REQ IND',
      headerTooltip: 'Id Required Indicator',
   },
   {
      field: 'locationCode',
      headerName: 'LOC CODE',
      headerTooltip: 'Location Code',
   },
   {
      field: 'locationTypeCode',
      headerName: 'LOC TYPE',
      headerTooltip: 'Location Type',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date',
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
];
export const CATEGORY_02_TABLE_HEADERS = [
   {
      field: 'daysOfWeek',
      headerName: 'DOW',
      headerTooltip: 'Day of the Week',
   },
   {
      field: 'startTimeOfDay',
      headerName: 'START TOD',
      headerTooltip: 'Start Time of day',
   },
   {
      field: 'stopTimeOfDay',
      headerName: 'STOP TOD',
      headerTooltip: 'Stop Time of day',
   },
   {
      field: 'timeApplicationCode',
      headerName: 'TOD IND',
      headerTooltip: 'Time Application Code',
   },
   {
      field: 'returnDayOccurrence',
      headerName: 'RET OCCUR',
      headerTooltip: 'Return Day Occurrence',
   },
   {
      field: 'returnSameDayInd',
      headerName: 'RET IND',
      headerTooltip: 'Return Ind',
   },
   {
      field: 'applicationTag',
      headerName: 'APP IND',
      headerTooltip: 'Application Ind',
   },
   {
      field: 'negateTag',
      headerName: 'NEG IND',
      headerTooltip: 'Negate Ind',
   },

   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date',
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'geographic995Id',
      headerName: 'GEO 995',
      headerTooltip: 'Geographic 995 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'geo995LocationType',
      headerName: 'LOCTYP 995',
      headerTooltip: 'Geo Location Type',
   },
   {
      field: 'geo995Location1Code',
      headerName: 'LOC1 995',
      headerTooltip: 'Geo Loc1 Code',
   },
   {
      field: 'geo995Location2Code',
      headerName: 'LOC2 995',
      headerTooltip: 'Geo Loc2 Code',
   },
   {
      field: 'geo995TravelSegmentIndicator',
      headerName: 'TSI 995',
      headerTooltip: 'Geo 995 TSI Ind',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
];
export const CATEGORY_05_TABLE_HEADERS = [
   {
      field: 'firstTimeOfDay',
      headerName: 'FIRST TOD',
      headerTooltip: 'First Time Of Day',
   },
   {
      field: 'firstPeriod',
      headerName: 'FIRST P',
      headerTooltip: 'First Period',
   },
   {
      field: 'firstUnit',
      headerName: 'FIRST U',
      headerTooltip: 'First Unit',
   },
   {
      field: 'lastTimeOfDay',
      headerName: 'LAST TOD',
      headerTooltip: 'Last Time Of Day',
   },
   {
      field: 'lastPeriod',
      headerName: 'LAST P',
      headerTooltip: 'Last Period',
   },
   {
      field: 'lastUnit',
      headerName: 'LAST U',
      headerTooltip: 'Last Unit',
   },
   {
      field: 'otherRestrictionIndicator',
      headerName: 'OTH RES IND',
      headerTooltip: 'Other Reservation Ind',
   },
   {
      field: 'immediateTicketingInd',
      headerName: 'IMM TKT IND',
      headerTooltip: 'Immediate Tkt Ind',
   },
   {
      field: 'notPermittedInd',
      headerName: 'NOT PERM IND',
      headerTooltip: 'Not Permitted Ind',
   },
   {
      field: 'waitListCode',
      headerName: 'WAIT CODE',
      headerTooltip: 'Waitlist Code',
   },
   {
      field: 'segmentConfirmedCode',
      headerName: 'SEG CODE',
      headerTooltip: 'Segment Confirm Code',
   },
   {
      field: 'eachSegmentInd',
      headerName: 'EACH SEG IND',
      headerTooltip: 'Each Segment Ind',
   },
   {
      field: 'ticketTimeOfDay',
      headerName: 'TKT TOD',
      headerTooltip: 'Ticketing time of day',
   },
   {
      field: 'ticketPeriod',
      headerName: 'TKT P',
      headerTooltip: 'Tkt Period',
   },
   {
      field: 'ticketUnit',
      headerName: 'TKT U',
      headerTooltip: 'Tkt Unit',
   },

   {
      field: 'departureOptionCode',
      headerName: 'DEPART OP CODE',
      headerTooltip: 'Depart Option code',
   },
   {
      field: 'timeBeforeDeparture',
      headerName: 'TIME DEPART',
      headerTooltip: 'Time before Depart',
   },
   {
      field: 'departureUnit',
      headerName: 'DEPART U',
      headerTooltip: 'Depart Unit',
   },
   {
      field: 'travelSegmentIndicator',
      headerName: 'TSI',
      headerTooltip: 'TSI',
   },
   {
      field: 'bothCode',
      headerName: 'BOTH CODE',
      headerTooltip: 'Both Code',
   },
   {
      field: 'exceptionTime',
      headerName: 'EXC TIME',
      headerTooltip: 'Exc Time',
   },
   {
      field: 'exceptionUnit',
      headerName: 'EXC UNIT',
      headerTooltip: 'EXC Unit',
   },
   {
      field: 'reservationDate',
      headerName: 'RES DATE',
      headerTooltip: 'Reservation Date',
   },
   {
      field: 'ticketDate',
      headerName: 'TKT DATE',
      headerTooltip: 'Ticket Date',
   },

   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'geographic995Id',
      headerName: 'GEO 995',
      headerTooltip: 'Geographic 995 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'geo995LocationType',
      headerName: 'LOCTYP 995',
      headerTooltip: 'Geo Location Type',
   },
   {
      field: 'geo995Location1Code',
      headerName: 'LOC1 995',
      headerTooltip: 'Geo Loc1 Code',
   },
   {
      field: 'geo995Location2Code',
      headerName: 'LOC2 995',
      headerTooltip: 'Geo Loc2 Code',
   },
   {
      field: 'geo995TravelSegmentIndicator',
      headerName: 'TSI 995',
      headerTooltip: 'Geo 995 TSI Ind',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
];
export const CATEGORY_06_TABLE_HEADERS = [
   {
      field: 'minimumStayPeriod',
      headerName: 'MIN STAY P',
      headerTooltip: 'Minimum Stay Period',
   },
   {
      field: 'minimumStayUnit',
      headerName: 'MIN STAY U',
      headerTooltip: 'Minimum Stay Unit',
   },
   {
      field: 'dayOfWeekInds',
      headerName: 'DOW IND',
      headerTooltip: 'Day Of Week Indicator',
   },
   {
      field: 'timeOfDay',
      headerName: 'TOD',
      headerTooltip: 'Time Of day',
   },
   {
      field: 'waiverCode',
      headerName: 'WAV CODE',
      headerTooltip: 'Waiver Code',
   },
   {
      field: 'earlierLaterCode',
      headerName: 'E/L CODE',
      headerTooltip: 'Earlier Later Code',
   },
   {
      field: 'minimumStayDate',
      headerName: 'MIN STAY D',
      headerTooltip: 'Minimum Stay Date',
   },
   {
      field: 'waiverDate',
      headerName: 'WAV DATE',
      headerTooltip: 'Waiver Date',
   },
   {
      field: 'waiverEarlierLaterCode',
      headerName: 'WAV E/L',
      headerTooltip: 'Waiver Earlier Later Code',
   },
   {
      field: 'waiverPeriod',
      headerName: 'WAV P',
      headerTooltip: 'Waiver Period',
   },
   {
      field: 'waiverUnit',
      headerName: 'WAV U',
      headerTooltip: 'Waiver Unit',
   },
   {
      field: 'applicationCode',
      headerName: 'APP CODE',
      headerTooltip: 'Application Code',
   },
   {
      field: 'greaterMileage',
      headerName: 'G MIL',
      headerTooltip: 'Greater Mileage',
   },
   {
      field: 'lesserMileage',
      headerName: 'L MIL',
      headerTooltip: 'Lesser Mileage',
   },

   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'fromGeographic995Id',
      headerName: 'FROM GEO 995',
      headerTooltip: 'From Geographic 995 Id',
   },
   {
      field: 'fromGeo995LocationType',
      headerName: 'FROM LOCTYP 995',
      headerTooltip: 'From Geo Location Type',
   },
   {
      field: 'fromGeo995Location1Code',
      headerName: 'FROM LOC1 995',
      headerTooltip: 'From Geo Loc1 Code',
   },
   {
      field: 'fromGeo995Location2Code',
      headerName: 'FROM LOC2 995',
      headerTooltip: 'From Geo Loc2 Code',
   },
   {
      field: 'fromGeo995TravelSegmentIndicator',
      headerName: 'FROM TSI 995',
      headerTooltip: 'From Geo TSI Ind',
   },
   {
      field: 'toGeographic995Id',
      headerName: 'TO GEO 995',
      headerTooltip: 'To Geographic 995 Id',
   },
   {
      field: 'toGeo995LocationType',
      headerName: 'TO LOCTYP 995',
      headerTooltip: 'To Geo Location Type',
   },
   {
      field: 'toGeo995Location1Code',
      headerName: 'TO LOC1 995',
      headerTooltip: 'To Geo Loc1 Code',
   },
   {
      field: 'toGeo995Location2Code',
      headerName: 'TO LOC2 995',
      headerTooltip: 'To Geo Loc2 Code',
   },
   {
      field: 'toGeo995TravelSegmentIndicator',
      headerName: 'TO TSI 995',
      headerTooltip: 'To Geo TSI Ind',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
];
export const CATEGORY_07_TABLE_HEADERS = [
   {
      field: 'maximumStayPeriod',
      headerName: 'MAXSTAYP',
      headerTooltip: 'Maximum Stay Period',
   },
   {
      field: 'maximumStayUnit',
      headerName: 'MAXSTAYU',
      headerTooltip: 'Maximum Stay Unit',
   },
   {
      field: 'returnTravelCode',
      headerName: 'RET CODE',
      headerTooltip: 'Return Travel Code',
   },
   {
      field: 'timeOfDay',
      headerName: 'TOD',
      headerTooltip: 'Time Of day',
   },
   {
      field: 'ticketIssuanceInd',
      headerName: 'TKT IND',
      headerTooltip: 'Ticketing Ind',
   },
   {
      field: 'earlierLaterCode',
      headerName: 'E/L CODE',
      headerTooltip: 'Earlier Later Code',
   },
   {
      field: 'maximumStayDate',
      headerName: 'MAX STAY D',
      headerTooltip: 'Maximum Stay Date',
   },
   {
      field: 'waiverCode',
      headerName: 'WAV CODE',
      headerTooltip: 'Waiver Code',
   },
   {
      field: 'waiverDate',
      headerName: 'WAV DATE',
      headerTooltip: 'Waiver Date',
   },
   {
      field: 'waiverEarlierLaterCode',
      headerName: 'WAV E/L',
      headerTooltip: 'Waiver Earlier Later Code',
   },
   {
      field: 'waiverPeriod',
      headerName: 'WAV P',
      headerTooltip: 'Waiver Period',
   },
   {
      field: 'waiverUnit',
      headerName: 'WAV U',
      headerTooltip: 'Waiver Unit',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date',
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'fromGeographic995Id',
      headerName: 'FROM GEO 995',
      headerTooltip: 'From Geographic 995 Id',
   },
   {
      field: 'fromGeo995LocationType',
      headerName: 'FROM LOCTYP 995',
      headerTooltip: 'From Geo Location Type',
   },
   {
      field: 'fromGeo995Location1Code',
      headerName: 'FROM LOC1 995',
      headerTooltip: 'From Geo Loc1 Code',
   },
   {
      field: 'fromGeo995Location2Code',
      headerName: 'FROM LOC2 995',
      headerTooltip: 'From Geo Loc2 Code',
   },
   {
      field: 'fromGeo995TravelSegmentIndicator',
      headerName: 'FROM TSI 995',
      headerTooltip: 'From Geo TSI Ind',
   },
   {
      field: 'toGeographic995Id',
      headerName: 'TO GEO 995',
      headerTooltip: 'To Geographic 995 Id',
   },
   {
      field: 'toGeo995LocationType',
      headerName: 'TO LOCTYP 995',
      headerTooltip: 'To Geo Location Type',
   },
   {
      field: 'toGeo995Location1Code',
      headerName: 'TO LOC1 995',
      headerTooltip: 'To Geo Loc1 Code',
   },
   {
      field: 'toGeo995Location2Code',
      headerName: 'TO LOC2 995',
      headerTooltip: 'To Geo Loc2 Code',
   },
   {
      field: 'toGeo995TravelSegmentIndicator',
      headerName: 'TO TSI 995',
      headerTooltip: 'To Geo TSI Ind',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
];
export const CATEGORY_08_TABLE_HEADERS = [
   {
      field: 'minimumNumber',
      headerName: 'MIN NUM',
      headerTooltip: 'Minimum number',
   },
   {
      field: 'maximumNumber',
      headerName: 'MAX NUM',
      headerTooltip: 'Maximum number',
   },
   {
      field: 'outboundNumber',
      headerName: 'OUT NUM',
      headerTooltip: 'Outbound number',
   },
   {
      field: 'inboundNumber',
      headerName: 'IN NUM',
      headerTooltip: 'Inbound Number',
   },
   {
      field: 'notBothInd',
      headerName: 'NOT BOTH IND',
      headerTooltip: 'Not Both Ind',
   },
   {
      field: 'openJawInd',
      headerName: 'OPEN JAW',
      headerTooltip: 'Open Jaw Ind',
   },
   {
      field: 'circleTrip2Ind',
      headerName: 'CIRCLE TRIP',
      headerTooltip: 'Circle Trip Ind',
   },
   {
      field: 'circleTrip2PlusInd',
      headerName: 'CIRCLE T PL',
      headerTooltip: 'Circle Trip Plus Ind',
   },
   {
      field: 'gatewayPermittedCode',
      headerName: 'GATE PERM',
      headerTooltip: 'Gateway Permitted Code',
   },
   {
      field: 'minimumTimePeriod',
      headerName: 'MIN TIME P',
      headerTooltip: 'Min Time Period',
   },
   {
      field: 'minimumTimeUnit',
      headerName: 'MIN TIME U',
      headerTooltip: 'Min Time Unit',
   },
   {
      field: 'maximumTimePeriod',
      headerName: 'MAX TIME P',
      headerTooltip: 'Max Time Period',
   },
   {
      field: 'maximumTimeUnit',
      headerName: 'MAX TIME U',
      headerTooltip: 'Max Time Unit',
   },
   {
      field: 'samePointStopovers',
      headerName: 'SAME STOP',
      headerTooltip: 'Same Points Stopovers',
   },
   {
      field: 'samePointTransits',
      headerName: 'SAME TRANSITS',
      headerTooltip: 'Same Points Transits',
   },
   {
      field: 'samePointConnections',
      headerName: 'SAME CONNECT',
      headerTooltip: 'Same Points Conn',
   },
   {
      field: 'application1Number',
      headerName: 'APP 1 IND',
      headerTooltip: 'Application 1 Ind',
   },
   {
      field: 'firstAmount1Code',
      headerName: 'FIRST AMT NUM',
      headerTooltip: 'First Amount Stop Num',
   },
   {
      field: 'firstAmount1Int',
      headerName: 'FIRST AMT',
      headerTooltip: 'First Amount',
   },
   {
      field: 'additionalAmount1Code',
      headerName: 'ADD AMT 1 NUM',
      headerTooltip: 'Additional Amount 1 Stop Num',
   },
   {
      field: 'additionalAmount1Int',
      headerName: 'ADD AMT 1',
      headerTooltip: 'Additional Amount 1',
   },
   {
      field: 'currency1Code',
      headerName: 'CURR 1 CODE',
      headerTooltip: 'Currency 1 Code',
   },
   {
      field: 'decimalPlace1',
      headerName: 'DEC 1 NO',
      headerTooltip: 'Decimal 1',
   },
   {
      field: 'firstAmount2Int',
      headerName: 'FIRST AMT 2',
      headerTooltip: 'First Amount 2',
   },
   {
      field: 'additionalAmount2Int',
      headerName: 'ADD AMT 2',
      headerTooltip: 'Additional Amount 2',
   },
   {
      field: 'currency2Code',
      headerName: 'CURR 2 CODE',
      headerTooltip: 'Currency 2 Code',
   },
   {
      field: 'decimalPlace2',
      headerName: 'DEC 2 NO',
      headerTooltip: 'Decimal 2',
   },
   {
      field: 'numberOfSegments',
      headerName: 'SEG NUM',
      headerTooltip: 'Number of Segments',
   },
   {
      field: 'stopOverLocationsSameCarrierCode',
      headerName: 'SAME CXR CODE',
      headerTooltip: 'Same Carrier code',
   },
   {
      field: 'stopOverLocationsNumberOfStopover',
      headerName: 'STOP NUM',
      headerTooltip: 'Number of Stopovers',
   },
   {
      field: 'stopOverLocationsInboundCarrierCode',
      headerName: 'IN CXR',
      headerTooltip: 'Inbound Carriers',
   },
   {
      field: 'stopOverLocationsApplicationCode',
      headerName: 'APP CODE',
      headerTooltip: 'Application Code',
   },
   {
      field: 'stopOverLocationsLocationTypeCode',
      headerName: 'LOC TYPE',
      headerTooltip: 'Location Type Code',
   },
   {
      field: 'stopOverLocationsLocation1Code',
      headerName: 'LOC 1 CODE',
      headerTooltip: 'Location 1 code',
   },
   {
      field: 'stopOverLocationsLocation2Code',
      headerName: 'LOC 2 CODE',
      headerTooltip: 'Location 2 code',
   },
   {
      field: 'stopOverLocationsOutboundCarrierCode',
      headerName: 'OUT CXR',
      headerTooltip: 'Outbound carrier code',
   },
   {
      field: 'stopOverLocationsInboundOutboundCode',
      headerName: 'I/O',
      headerTooltip: 'I/O ind',
   },
   {
      field: 'stopOverLocationsChargeCode',
      headerName: 'CHARGE CODE',
      headerTooltip: 'Charge code',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'gatewayTable995Id',
      headerName: 'GEO 995',
      headerTooltip: 'Geographic 995 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'gateway995LocationType',
      headerName: 'LOCTYP 995',
      headerTooltip: 'Geo Location Type',
   },
   {
      field: 'gateway995Location1Code',
      headerName: 'LOC1 995',
      headerTooltip: 'Geo Loc1 Code',
   },
   {
      field: 'gateway995Location2Code',
      headerName: 'LOC2 995',
      headerTooltip: 'Geo Loc2 Code',
   },
   {
      field: 'gateway995TravelSegmentIndicator',
      headerName: 'TSI 995',
      headerTooltip: 'Geo 995 TSI Ind ',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
   {
      field: 'samePoints993Id',
      headerName: 'POINT 993',
      headerTooltip: 'Same Points 993 ID',
   },
];
export const CATEGORY_12_TABLE_HEADERS = [
   {
      field: 'startPeriod',
      headerName: 'START P',
      headerTooltip: 'Start Period',
   },
   {
      field: 'stopPeriod',
      headerName: 'STOP P',
      headerTooltip: 'Stop Period',
   },
   {
      field: 'firstTimeOfDay',
      headerName: 'FIRST TOD',
      headerTooltip: 'First Time Of Day',
   },
   {
      field: 'lastTimeOfDay',
      headerName: 'LAST TOD',
      headerTooltip: 'Last Time Of Day',
   },
   {
      field: 'timeOfDayApplicationInd',
      headerName: 'TOD APP IND',
      headerTooltip: 'Time Of Day App Ind',
   },
   {
      field: 'dayOfWeekInds',
      headerName: 'DOW IND',
      headerTooltip: 'Day Of Week Indicator',
   },
   {
      field: 'surchargeType',
      headerName: 'SUR TYPE',
      headerTooltip: 'Surcharge Type',
   },
   {
      field: 'equipmentCode',
      headerName: 'EQP CODE',
      headerTooltip: 'Equipment Code',
   },
   {
      field: 'travelPortionInd',
      headerName: 'TVL POR IND',
      headerTooltip: 'Travel Portion Ind',
   },
   {
      field: 'equipmentCode',
      headerName: 'SEC POR IND',
      headerTooltip: 'Sector Portion Ind    ',
   },
   {
      field: 'applicationCode',
      headerName: 'APP CODE',
      headerTooltip: 'Application Code',
   },
   {
      field: 'surcharge1Amount',
      headerName: 'SUR 1 AMT',
      headerTooltip: 'Surcharge 1 Amount',
   },
   {
      field: 'currency1Code',
      headerName: 'CURR 1 CODE',
      headerTooltip: 'Currency 1 Code',
   },
   {
      field: 'surcharge2Amount',
      headerName: 'SUR 2 AMT',
      headerTooltip: 'Surcharge 2 Amount',
   },
   {
      field: 'currency2Code',
      headerName: 'CURR 2 CODE',
      headerTooltip: 'Currency 2 Code',
   },
   {
      field: 'percent',
      headerName: 'PERCENT',
      headerTooltip: 'Percent',
   },
   {
      field: 'percentApplicationCode',
      headerName: 'PER APP CODE',
      headerTooltip: 'Percent Application Code',
   },
   {
      field: 'reservationBookingDesignator',
      headerName: 'RBD',
      headerTooltip: 'RBD',
   },
   {
      field: 'carrierFlight986Id',
      headerName: 'FLIGHT 986 ID',
      headerTooltip: 'Carrier Flight 986 Id',
   },
   {
      field: 'carrierFlight986Id',
      headerName: 'FLIGHT 986',
      headerTooltip: 'Carrier Flight 986',
   },
   {
      field: 'carrierFlight986Id',
      headerName: 'FLIGHT 986',
      headerTooltip: 'Carrier Flight 986',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date',
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'geographic995Id',
      headerName: 'GEO 995',
      headerTooltip: 'Geographic 995 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'geo995LocationType',
      headerName: 'LOCTYP 995',
      headerTooltip: 'Geo Location Type',
   },
   {
      field: 'geo995Location1Code',
      headerName: 'LOC1 995',
      headerTooltip: 'Geo Loc1 Code',
   },
   {
      field: 'geo995Location2Code',
      headerName: 'LOC2 995',
      headerTooltip: 'Geo Loc2 Code',
   },
   {
      field: 'geo995TravelSegmentIndicator',
      headerName: 'TSI 995',
      headerTooltip: 'Geo 995 TSI Ind',
   },
   {
      field: 'betweenTable995Id',
      headerName: 'BET GEO 995',
      headerTooltip: 'Between Geographic 995 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'between995LocationType',
      headerName: 'BET LOCTYP',
      headerTooltip: 'Between Geo Location Type',
   },
   {
      field: 'between995Location1Code',
      headerName: 'BET LOC1',
      headerTooltip: 'Between Geo Loc1 Code',
   },
   {
      field: 'between995Location2Code',
      headerName: 'BET LOC2',
      headerTooltip: 'Between Geo Loc2 Code',
   },
   {
      field: 'between995TravelSegmentIndicator',
      headerName: 'BET TSI',
      headerTooltip: 'Between Geo TSI Ind',
   },
   {
      field: 'andTable995Id',
      headerName: 'AND GEO 995',
      headerTooltip: 'And Geographic 995 Id',
   },
   {
      field: 'and995LocationType',
      headerName: 'AND LOCTYP',
      headerTooltip: 'And Geo Location Type',
   },
   {
      field: 'and995Location1Code',
      headerName: 'AND LOC1',
      headerTooltip: 'And Geo Loc1 Code',
   },
   {
      field: 'and995Location2Code',
      headerName: 'AND LOC2',
      headerTooltip: 'And Geo Loc2 Code',
   },
   {
      field: 'and995TravelSegmentIndicator',
      headerName: 'AND TSI',
      headerTooltip: 'And Geo TSI Ind',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
];
export const CATEGORY_13_TABLE_HEADERS = [
   {
      field: 'allSectorsInd',
      headerName: 'ALL SEC IND',
      headerTooltip: 'All Sectors Ind',
   },
   {
      field: 'outboundJourneyInd',
      headerName: 'OUT JRNY IND',
      headerTooltip: 'Outbound Journey Ind',
   },
   {
      field: 'atLeastOneSectorInd',
      headerName: 'ONE SEC IND',
      headerTooltip: 'Atleast One Sector Ind',
   },
   {
      field: 'sameCompartmentInd',
      headerName: 'SAME COM IND',
      headerTooltip: 'Same Compartment Ind',
   },
   {
      field: 'sameRuleInd',
      headerName: 'SAME RUL IND',
      headerTooltip: 'Same Rule Ind',
   },
   {
      field: 'accompanyingPassengerInd',
      headerName: 'ACC PASS IND',
      headerTooltip: 'Accompany Passenger Ind',
   },
   {
      field: 'accompanyingPassengerInd',
      headerName: 'ACC PASS IND',
      headerTooltip: 'Accompany Passenger Ind',
   },
   {
      field: 'passengerTypeCode',
      headerName: 'PTC',
      headerTooltip: 'Passenger Type Code',
   },
   {
      field: 'passengerTypeCode',
      headerName: 'PTC',
      headerTooltip: 'Passenger Type Code',
   },
   {
      field: 'idRequirementInd',
      headerName: 'ID REQ IND',
      headerTooltip: 'Id Required Indicator',
   },
   {
      field: 'minimumAge',
      headerName: 'MIN AGE',
      headerTooltip: 'Minimum Age',
   },
   {
      field: 'maximumAge',
      headerName: 'MAX AGE',
      headerTooltip: 'Maximum Age',
   },
   {
      field: 'minimumNumber',
      headerName: 'MIN NUM',
      headerTooltip: 'Minimum number',
   },
   {
      field: 'maximumNumber',
      headerName: 'MAX NUM',
      headerTooltip: 'Maximum number',
   },
   {
      field: 'fareBookingInd',
      headerName: 'FARE BOOK',
      headerTooltip: 'Fare Booking Ind',
   },
   {
      field: 'numberOfSegments',
      headerName: 'SEG NUM',
      headerTooltip: 'Number of Segments',
   },
   {
      field: 'accompanyingTravelCodeListFareClassBookingCode',
      headerName: 'FBC',
      headerTooltip: 'Fare Class code',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip:  'Override Reser Disc Date',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
];
export const CATEGORY_16_TABLE_HEADERS = [
   {
      field: 'voluntaryInd',
      headerName: 'VOL IND',
      headerTooltip: 'Voluntary Changes',
   },
   {
      field: 'involuntaryInd',
      headerName: 'INVOL IND',
      headerTooltip: 'Involuntary Changes',
   },
   {
      field: 'cancellationsInd',
      headerName: 'CAN REF',
      headerTooltip: 'Cancellation and Refunds',
   },
   {
      field: 'ticketRefundCode',
      headerName: 'TKT REF',
      headerTooltip: 'Ticket Refund Ind',
   },
   {
      field: 'cancelInd',
      headerName: 'CAN IND',
      headerTooltip: 'Cancellation Ind',
   },
   {
      field: 'failureInd',
      headerName: 'FAIL IND',
      headerTooltip: 'Failure Ind',
   },
   {
      field: 'reissueInd',
      headerName: 'REISSUE IND',
      headerTooltip: 'Reissue Ind',
   },
   {
      field: 'replaceInd',
      headerName: 'REPLACE IND',
      headerTooltip: 'Replace Ind',
   },
   {
      field: 'changeInd',
      headerName: 'CHANGE IND',
      headerTooltip: 'Change Ind',
   },
   {
      field: 'ptaInd',
      headerName: 'PTA IND',
      headerTooltip: 'PTA Ind',
   },
   {
      field: 'refundInd',
      headerName: 'REFUND IND',
      headerTooltip: 'Refund Ind',
   },
   {
      field: 'applicationCode',
      headerName: 'APP CODE',
      headerTooltip: 'Application Code',
   },
   {
      field: 'portionCode',
      headerName: 'POR CODE',
      headerTooltip: 'Portion code',
   },
   {
      field: 'penalty1Amount',
      headerName: 'PENALTY 1 AMT',
      headerTooltip: 'Penalty 1 Amount',
   },
   {
      field: 'currency1Code',
      headerName: 'CURR 1 CODE',
      headerTooltip: 'Currency 1 Code',
   },
   {
      field: 'penalty2Amount',
      headerName: 'PENALTY 2 AMT',
      headerTooltip: 'Penalty 2 Amount',
   },
   {
      field: 'currency2Code',
      headerName: 'CURR 2 CODE',
      headerTooltip: 'Currency 2 Code',
   },
   {
      field: 'percent',
      headerName: 'PERCENT',
      headerTooltip: 'Percent',
   },
   {
      field: 'highLowCode',
      headerName: 'H/L IND',
      headerTooltip: 'High Low Ind',
   },
   {
      field: 'deathInd',
      headerName: 'DEA WAV IND',
      headerTooltip: 'Death Waiver Ind',
   },
   {
      field: 'illnessInd',
      headerName: 'ILL WAV IND',
      headerTooltip: 'Illness Waiver Ind',
   },
   {
      field: 'familyDeathInd',
      headerName: 'F DEA WAV IND',
      headerTooltip: 'Family Death Waiver',
   },
   {
      field: 'familyIllnessInd',
      headerName: 'F ILL WAV IND',
      headerTooltip: 'Family Illness Waiver',
   },
   {
      field: 'scheduleChangeInd',
      headerName: 'SCH C IND',
      headerTooltip: 'Schedule Change Ind',
   },
   {
      field: 'ticketUpgradeInd',
      headerName: 'TKT UG IND',
      headerTooltip: 'Ticket Upgrade Ind',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'geographic995Id',
      headerName: 'GEO 995',
      headerTooltip: 'Geographic 995 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'geo995LocationType',
      headerName: 'LOCTYP 995',
      headerTooltip: 'Geo Location Type',
   },
   {
      field: 'geo995Location1Code',
      headerName: 'LOC1 995',
      headerTooltip: 'Geo Loc1 Code',
   },
   {
      field: 'geo995Location2Code',
      headerName: 'LOC2 995',
      headerTooltip: 'Geo Loc2 Code',
   },
   {
      field: 'geo995TravelSegmentIndicator',
      headerName: 'TSI 995',
      headerTooltip: 'Geo 995 TSI Ind',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
];
export const CATEGORY_17_TABLE_HEADERS = [
   {
      field: 'locationTypeCode',
      headerName: 'LOC TYPE CODE',
      headerTooltip: 'Location Type Code',
   },
   {
      field: 'location1Code',
      headerName: 'LOC 1 CODE',
      headerTooltip: 'Location 1 code',
   },
   {
      field: 'location2Code',
      headerName: 'LOC 2 CODE',
      headerTooltip: 'Location 2 code',
   },
   {
      field: 'connectionOrStopOverPoint',
      headerName: 'CXN STOP',
      headerTooltip: 'Connection or Stopover',
   },
   {
      field: 'noHipCode',
      headerName: 'NO HIP',
      headerTooltip: 'No Higher Intermediate',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
];
export const CATEGORY_28_TABLE_HEADERS = [
   {
      field: 'passengerTypeCode4',
      headerName: 'PTC',
      headerTooltip: 'Passenger Type Code',
   },
   {
      field: 'identificationTag',
      headerName: 'IND TAG',
      headerTooltip: 'Identification Tag',
   },
   {
      field: 'minimumAgeOfPassenger',
      headerName: 'MIN AGE',
      headerTooltip: 'Minimum Age',
   },
   {
      field: 'maximumAgeOfPassenger',
      headerName: 'MAX AGE',
      headerTooltip: 'Maximum Age',
   },
   {
      field: 'residentCode',
      headerName: 'RES CODE',
      headerTooltip: 'Resident Code',
   },
   {
      field: 'travelIndicator',
      headerName: 'TVL IND',
      headerTooltip: 'Travel Ind',
   },
   {
      field: 'numberOfMiles',
      headerName: 'NO OF MILES',
      headerTooltip: 'Number of Miles',
   },
   {
      field: 'vacTypeTicketIndicator',
      headerName: 'TKT TYPE IND',
      headerTooltip: 'Ticket Type Ind',
   },
   {
      field: 'localeGeographic995Id',
      headerName: 'LOCALE GEO',
      headerTooltip: 'Locale Geo 995 Id',
   },
   {
      field: 'localeGeo995LocationType',
      headerName: 'LOCALE LOCTYP',
      headerTooltip: 'Locale Geo Loc Type',
   },
   {
      field: 'localeGeo995Location1Code',
      headerName: 'LOCALE LOC1',
      headerTooltip: 'Locale Geo Loc1 Code',
   },
   {
      field: 'localeGeo995Location2Code',
      headerName: 'LOCALE LOC2',
      headerTooltip: 'Locale Geo Loc2 Code',
   },
   {
      field: 'localeGeo995TravelSegmentIndicator',
      headerName: 'LOCALE TSI',
      headerTooltip: 'Locale Geo TSI Ind',
   },
   {
      field: 'nonResidenceGeographic995Id',
      headerName: 'NON R GEO',
      headerTooltip: 'Non Residence Geo 995 Id',
   },
   {
      field: 'nonResGeo995LocationType',
      headerName: 'NON R LOCTYP',
      headerTooltip: 'Non Res Geo Location Type',
   },
   {
      field: 'nonResGeo995Location1Code',
      headerName: 'NON R LOC1',
      headerTooltip: 'Non Res Geo Loc1 Code',
   },
   {
      field: 'nonResGeo995Location2Code',
      headerName: 'NON R LOC2',
      headerTooltip: 'Non Res Geo Loc2 Code',
   },
   {
      field: 'nonResGeo995TravelSegmentIndicator',
      headerName: 'NON R TSI',
      headerTooltip: 'Non Res Geo TSI Ind',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
];
export const CATEGORY_29_TABLE_HEADERS = [
   {
      field: 'depositRequiredCode',
      headerName: 'DEP REQ CODE',
      headerTooltip: 'Deposit Req Code',
   },
   {
      field: 'firstMinimumDepositAmount',
      headerName: 'FIRST MIN AMT',
      headerTooltip: 'First Min Deposit Amt',
   },
   {
      field: 'firstDepositCurrencyCode',
      headerName: 'FIRST MIN CURR',
      headerTooltip: 'First Min Deposit Curr',
   },
   {
      field: 'decimalPlacesForFirstCurrency',
      headerName: 'FIRST MIN DEC',
      headerTooltip: 'First Min Deposit Decimal',
   },
   {
      field: 'secondMinimumDepositAmount',
      headerName: 'SEC MIN AMT',
      headerTooltip: 'Sec Min Deposit Amt',
   },
   {
      field: 'secondDepositCurrencyCode',
      headerName: 'SEC MIN CURR',
      headerTooltip: 'Sec Min Deposit Curr',
   },
   {
      field: 'decimalPlacesForSecondCurrency',
      headerName: 'SEC MIN DEC',
      headerTooltip: 'Sec Min Deposit Decimal',
   },
   {
      field: 'farePercentToDeposit',
      headerName: 'FARE PER DEP',
      headerTooltip: 'Fare Percent To Deposit',
   },
   {
      field: 'depositApplCode',
      headerName: 'DEP APP CODE',
      headerTooltip: 'Deposit App Code',
   },
   {
      field: 'depositDays',
      headerName: 'DEP CODE',
      headerTooltip: 'Deposit Code',
   },
   {
      field: 'lastDate',
      headerName: 'LAST DATE',
      headerTooltip: 'Last Date',
   },
   {
      field: 'seatDepositIndicator',
      headerName: 'SEAT DEP IND',
      headerTooltip: 'Seat Deposit Ind',
   },
   {
      field: 'nonRefundableDepositIndicator',
      headerName: 'NON REF IND',
      headerTooltip: 'Non Refundable Deposit Ind',
   },
   {
      field: 'firstRefundableAmount',
      headerName: 'FIRST REF AMT',
      headerTooltip: 'First Refund Amount',
   },
   {
      field: 'firstRefundCurrencyCode',
      headerName: 'FIRST REF CURR',
      headerTooltip: 'First Refund Curr',
   },
   {
      field: 'decimalPlacesForFirstRefundCurrency',
      headerName: 'FIRST REF DEC',
      headerTooltip: 'First Refund Decimal',
   },
   {
      field: 'secondRefundableAmount',
      headerName: 'SEC REF AMT',
      headerTooltip: 'Sec Refund Amount',
   },
   {
      field: 'secondRefundCurrencyCode',
      headerName: 'SEC REF CURR',
      headerTooltip: 'Sec Refund Curr',
   },
   {
      field: 'decimalPlacesForSecondRefundCurrency',
      headerName: 'SEC REF DEC',
      headerTooltip: 'Sec Refund Decimal',
   },
   {
      field: 'refundPercent',
      headerName: 'REF PERCENT',
      headerTooltip: 'Refund Percent',
   },
   {
      field: 'refundApplCode',
      headerName: 'REF APP CODE',
      headerTooltip: 'Refund Application Code',
   },
   {
      field: 'refundDays',
      headerName: 'REF DAYS',
      headerTooltip: 'Refund Days',
   },
   {
      field: 'waiversApplCode',
      headerName: 'WAV APP CODE',
      headerTooltip: 'Waiver App Code',
   },
   {
      field: 'deathCode',
      headerName: 'DEATH CODE',
      headerTooltip: 'Death Code',
   },
   {
      field: 'illnessCode',
      headerName: 'ILL CODE',
      headerTooltip: 'Illness Code',
   },
   {
      field: 'scheduleChange',
      headerName: 'SCH CHANGE',
      headerTooltip: 'Schedule Change',
   },
   {
      field: 'ticketUpgrade',
      headerName: 'TKT UG',
      headerTooltip: 'Ticket Upgrade',
   },
   {
      field: 'denialOfDocuments',
      headerName: 'DENIAL DOCS',
      headerTooltip: 'Denial Of Docs',
   },
   {
      field: 'juryDuty',
      headerName: 'JURY DUTY',
      headerTooltip: 'Jury Duty',
   },
   {
      field: 'militaryOrders',
      headerName: 'MIL ORDER',
      headerTooltip: 'Military Orders',
   },
   {
      field: 'airfareIncrease',
      headerName: 'AIRFARE INC',
      headerTooltip: 'Airfare Increase',
   },
   {
      field: 'fullyPaidForSeats',
      headerName: 'FULL SEATS',
      headerTooltip: 'Full Paid Seats',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'depositGeographic995Id',
      headerName: 'DEP GEO 995',
      headerTooltip: 'Deposit Geo 995 Id',
   },
   {
      field: 'deposit995LocationType',
      headerName: 'DEP LOCTYP',
      headerTooltip: 'Dep Geo Location Type',
   },
   {
      field: 'deposit995Location1Code',
      headerName: 'DEP LOC1',
      headerTooltip: 'Dep Geo Loc1 Code',
   },
   {
      field: 'deposit995Location2Code',
      headerName: 'DEP LOC2',
      headerTooltip: 'Dep Geo Loc2 Code',
   },
   {
      field: 'deposit995TravelSegmentIndicator',
      headerName: 'DEP TSI',
      headerTooltip: 'Dep Geo TSI Ind',
   },
   {
      field: 'refundGeographic995Id',
      headerName: 'REF GEO 995',
      headerTooltip: 'Refund Geo 995 Id',
   },
   {
      field: 'refund995LocationType',
      headerName: 'REF LOCTYP',
      headerTooltip: 'Ref Geo Location Type',
   },
   {
      field: 'refund995Location1Code',
      headerName: 'REF LOC1',
      headerTooltip: 'Ref Geo Loc1 Code',
   },
   {
      field: 'refund995Location2Code',
      headerName: 'REF LOC2',
      headerTooltip: 'Ref Geo Loc2 Code',
   },
   {
      field: 'refund995TravelSegmentIndicator',
      headerName: 'REF TSI',
      headerTooltip: 'Ref Geo TSI Ind',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
];
export const CATEGORY_31_TABLE_HEADERS = [
   {
      field: 'passengerTypeCode',
      headerName: 'PTC',
      headerTooltip: 'Passenger Type Code',
   },
   {
      field: 'ticketValidityInd',
      headerName: 'TKT VAL IND',
      headerTooltip: 'Ticket Validity Ind',
   },
   {
      field: 'journeyCode',
      headerName: 'JRNY CODE',
      headerTooltip: 'Journey Code',
   },
   {
      field: 'pricingUnit',
      headerName: 'PRICE UNIT',
      headerTooltip: 'Pricing Unit',
   },
   {
      field: 'fareComponentCode',
      headerName: 'FARE CO CODE',
      headerTooltip: 'Fare Component code',
   },
   {
      field: 'fromPointCode',
      headerName: 'FROM CODE',
      headerTooltip: 'From Point Code',
   },
   {
      field: 'toPointCode',
      headerName: 'TO CODE',
      headerTooltip: 'To Point code',
   },
   {
      field: 'lastPeriod',
      headerName: 'LAST P',
      headerTooltip: 'Last Period',
   },
   {
      field: 'lastUnit',
      headerName: 'LAST U',
      headerTooltip: 'Last Unit',
   },
   {
      field: 'changeInd',
      headerName: 'CHANGE IND',
      headerTooltip: 'Change Ind',
   },
   {
      field: 'firstOccurrence',
      headerName: 'FIRST OCC',
      headerTooltip: 'First Occurrence',
   },
   {
      field: 'lastOccurrence',
      headerName: 'LAST OCC',
      headerTooltip: 'Last Occurrence',
   },
   {
      field: 'penalty1Amount',
      headerName: 'PEN 1 AMT',
      headerTooltip: 'Penalty 1 Amount',
   },
   {
      field: 'currency1Code',
      headerName: 'CURR 1',
      headerTooltip: 'Currency 1 Code',
   },
   {
      field: 'decimalPlace1',
      headerName: 'DEC 1 NO',
      headerTooltip: 'Decimal 1',
   },
   {
      field: 'penaltyPercent',
      headerName: 'PEN PERCENT',
      headerTooltip: 'Penalty Percent',
   },
   {
      field: 'penalty2Amount',
      headerName: 'PEN 2 AMT',
      headerTooltip: 'Penalty 2 Amount',
   },
   {
      field: 'currency2Code',
      headerName: 'CURR 2',
      headerTooltip: 'Currency 2 Code',
   },
   {
      field: 'decimalPlace2',
      headerName: 'DEC 2 NO',
      headerTooltip: 'Decimal 2',
   },
   {
      field: 'highLowCode',
      headerName: 'H/L CODE',
      headerTooltip: 'High Low Code',
   },
   {
      field: 'minimumAmount',
      headerName: 'MIN AMT',
      headerTooltip: 'Minimum Amount',
   },
   {
      field: 'currencyCode',
      headerName: 'CURR CODE',
      headerTooltip: 'Currency code',
   },
   {
      field: 'decimalsNumber',
      headerName: 'DEC',
      headerTooltip: 'Decimal',
   },
   {
      field: 'assessmentCode',
      headerName: 'ASSESS CODE',
      headerTooltip: 'Assessment code',
   },
   {
      field: 'feeApplicationCode',
      headerName: 'FEE APP CODE',
      headerTooltip: 'Fee Application code',
   },
   {
      field: 'ticketTypeCode',
      headerName: 'TKT TYPE',
      headerTooltip: 'Ticket Type code',
   },
   {
      field: 'discountTypeCode',
      headerName: 'DIS TYPE',
      headerTooltip: 'Discount Type Code',
   },
   {
      field: 'residualPenaltyCode',
      headerName: 'RES TYPE',
      headerTooltip: 'Residual Penalty Code',
   },
   {
      field: 'refundTypeCode',
      headerName: 'REF TYPE',
      headerTooltip: 'Refund Type Code',
   },
   {
      field: 'endorsementInd',
      headerName: 'ENDO TYPE',
      headerTooltip: 'Endorsement Ind',
   },
   {
      field: 'reissue988Id',
      headerName: 'REISSUE 988',
      headerTooltip: 'Reissue 988 Id',
   },
   {
      field: 'waiver987Id',
      headerName: 'WAIVER 987',
      headerTooltip: 'Waiver 987 Id',
   },
   {
      field: 'waiver987Id',
      headerName: 'WAIVER 987',
      headerTooltip: 'Waiver 987 Id',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
];
export const CATEGORY_33_TABLE_HEADERS = [
   {
      field: 'passengerTypeCode',
      headerName: 'PTC',
      headerTooltip: 'Passenger Type Code',
   },
   {
      field: 'ticketValidityInd',
      headerName: 'TKT VAL IND',
      headerTooltip: 'Ticket Validity Ind',
   },
   {
      field: 'ticketPeriod',
      headerName: 'TKT P',
      headerTooltip: 'Ticket Period',
   },
   {
      field: 'ticketUnit',
      headerName: 'TKT U',
      headerTooltip: 'Ticket Unit',
   },
   {
      field: 'journeyCode',
      headerName: 'JRNY CODE',
      headerTooltip: 'Journey Code',
   },
   {
      field: 'pricingUnit',
      headerName: 'PRICE UNIT',
      headerTooltip: 'Pricing Unit',
   },
   {
      field: 'fareComponentCode',
      headerName: 'FARE CO CODE',
      headerTooltip: 'Fare Component code',
   },
   {
      field: 'fromPointCode',
      headerName: 'FROM CODE',
      headerTooltip: 'From Point Code',
   },
   {
      field: 'lastTimeOfDay',
      headerName: 'LAST TOD',
      headerTooltip: 'Last Time Of Day',
   },
   {
      field: 'lastPeriod',
      headerName: 'LAST P',
      headerTooltip: 'Last Period',
   },
   {
      field: 'lastUnit',
      headerName: 'LAST U',
      headerTooltip: 'Last Unit',
   },
   {
      field: 'ticketTimeLimit',
      headerName: 'TKT LIMIT',
      headerTooltip: 'Ticket Time Limit',
   },
   {
      field: 'advanceReservationsValidation',
      headerName: 'ADV RES',
      headerTooltip: 'Advance Reservation',
   },
   {
      field: 'fullyFlown',
      headerName: 'FULL FLOWN',
      headerTooltip: 'Fully Flown',
   },
   {
      field: 'originallyScheduledRefund',
      headerName: 'ORG SCH REF',
      headerTooltip: 'Originally Scheduled Refund',
   },
   {
      field: 'originallyScheduledPeriod',
      headerName: 'ORG SCH P',
      headerTooltip: 'Originally Scheduled Period',
   },
   {
      field: 'originallyScheduledUnit',
      headerName: 'ORG SCH U',
      headerTooltip: 'Originally Scheduled Unit',
   },
   {
      field: 'cancellationIndicator',
      headerName: 'CANCEL IND',
      headerTooltip: 'Cancellation Ind',
   },
   {
      field: 'fareBreakPoints',
      headerName: 'FARE POINT',
      headerTooltip: 'Fare Break Points',
   },
   {
      field: 'rePriceIndicator',
      headerName: 'RE IND',
      headerTooltip: 'Re Price Ind',
   },
   {
      field: 'ruleTariffNumber',
      headerName: 'RTN',
      headerTooltip: 'Rule Tariff Number',
   },
   {
      field: 'pvtPubTariffIndicator',
      headerName: 'PVT PUB IND',
      headerTooltip: 'Private Public Ind',
   },
   {
      field: 'ruleNumber',
      headerName: 'RULE NUM',
      headerTooltip: 'Rule Number',
   },
   {
      field: 'fieldIndicator',
      headerName: 'FIELD IND',
      headerTooltip: 'Field Ind',
   },
   {
      field: 'fareClassCode',
      headerName: 'FCC',
      headerTooltip: 'Fare Class Code',
   },
   {
      field: 'sameCode',
      headerName: 'SAME CODE',
      headerTooltip: 'Same Code',
   },
   {
      field: 'normalSpecialFareCode',
      headerName: 'FARE CODE',
      headerTooltip: 'Special Fare Code',
   },
   {
      field: 'owRtIndString',
      headerName: 'OW/RT',
      headerTooltip: 'OW/RT Ind',
   },
   {
      field: 'fareAmountCode',
      headerName: 'FARE AMT',
      headerTooltip: 'Fare Amount Code',
   },
   {
      field: 'bookingCode',
      headerName: 'BOOK CODE',
      headerTooltip: 'Booking Code',
   },
   {
      field: 'penaltyAmount1',
      headerName: 'PEN 1 AMT',
      headerTooltip: 'Penalty 1 Amount',
   },
   {
      field: 'currencyCode1',
      headerName: 'CURR 1 CODE',
      headerTooltip: 'Currency 1 Code',
   },
   {
      field: 'decimalPlace1',
      headerName: 'DEC 1 NO',
      headerTooltip: 'Decimal 1',
   },
   {
      field: 'baseFarePercentage',
      headerName: 'BASE PERCENT',
      headerTooltip: 'Base Fare Percent',
   },
   {
      field: 'penaltyAmount2',
      headerName: 'PEN 2 AMT',
      headerTooltip: 'Penalty 2 Amount',
   },
   {
      field: 'currency2Code',
      headerName: 'CURR 2',
      headerTooltip: 'Currency 2 Code',
   },
   {
      field: 'decimalPlace2',
      headerName: 'DEC 2 NO',
      headerTooltip: 'Decimal 2',
   },
   {
      field: 'higherLowerAmountCode',
      headerName: 'H/L AMT',
      headerTooltip: 'High Low Amount Code',
   },
   {
      field: 'minimumAmount',
      headerName: 'MIN AMT',
      headerTooltip: 'Minimum Amount',
   },
   {
      field: 'currencyCode3',
      headerName: 'CURR 3',
      headerTooltip: 'Currency 3 Code',
   },
   {
      field: 'decimalPlace3',
      headerName: 'DEC 3 NO',
      headerTooltip: 'Decimal 3',
   },
   {
      field: 'puFCCode',
      headerName: 'PU/FC',
      headerTooltip: 'PU/FC Code',
   },
   {
      field: 'calculationOption',
      headerName: 'CALC OP',
      headerTooltip: 'Calculation Option',
   },
   {
      field: 'discountTag',
      headerName: 'DIS TAG',
      headerTooltip: 'Discount Tag',
   },
   {
      field: 'formOfRefund',
      headerName: 'REFUND',
      headerTooltip: 'Form Of refund',
   },
   {
      field: 'taxNonRefundCode',
      headerName: 'NON REF CODE',
      headerTooltip: 'Tax Non Refund Code',
   },
   {
      field: 'custFirstPeriod',
      headerName: 'CUST P',
      headerTooltip: 'Customer First Period',
   },
   {
      field: 'custFirstUnit',
      headerName: 'CUST U',
      headerTooltip: 'Customer First Unit',
   },
   {
      field: 'reservationTicketingCode',
      headerName: 'RES TKT CODE',
      headerTooltip: 'Reservation Ticketing Code',
   },
   {
      field: 'carrier990Id',
      headerName: 'CXR 990',
      headerTooltip: 'Carrier 990 Id',
   },
   {
      field: 'fareTypeTable974Id',
      headerName: 'FARE TYPE 974',
      headerTooltip: 'Fare Type Table 974 Id',
   },
   {
      field: 'waiver987Id',
      headerName: 'WAV 987',
      headerTooltip: 'Waiver 987 Id',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
];
export const CATEGORY_50_TABLE_HEADERS = [
   {
      field: 'applicationTitle',
      headerName: 'APP TITLE',
      headerTooltip: 'Application Title',
   },
   {
      field: 'firstClassInd',
      headerName: 'FIRST CLASS',
      headerTooltip: 'First Class Ind',
   },
   {
      field: 'businessClassInd',
      headerName: 'BUS CLASS',
      headerTooltip: 'Business Class Ind',
   },
   {
      field: 'economyClassInd',
      headerName: 'ECO CLASS',
      headerTooltip: 'Economy Class Ind',
   },
   {
      field: 'coachClassInd',
      headerName: 'COACH CLASS',
      headerTooltip: 'Coach Class Ind',
   },
   {
      field: 'offPeakCoachClassInd',
      headerName: 'OFF CO CLASS',
      headerTooltip: 'Off Peak Coach Ind',
   },
   {
      field: 'supersonicInd',
      headerName: 'SUPER IND',
      headerTooltip: 'Supersonic Ind',
   },
   {
      field: 'oneWayRuleInd',
      headerName: 'OW RULE IND',
      headerTooltip: 'One Way Rule Ind',
   },
   {
      field: 'roundTripRuleInd',
      headerName: 'RT RULE IND',
      headerTooltip: 'Round Trip Rule Ind',
   },
   {
      field: 'oneWayInd',
      headerName: 'OW IND',
      headerTooltip: 'One Way Ind',
   },
   {
      field: 'roundTripInd',
      headerName: 'RT IND',
      headerTooltip: 'Round Trip Ind',
   },
   {
      field: 'circleTripInd',
      headerName: 'CT IND',
      headerTooltip: 'Circle Trip Ind',
   },
   {
      field: 'openJawInd',
      headerName: 'OJ IND',
      headerTooltip: 'Open Jaw Ind',
   },
   {
      field: 'singleOpenJawInd',
      headerName: 'SOJ IND',
      headerTooltip: 'Single Open Jaw Ind',
   },
   {
      field: 'originSojInd',
      headerName: 'ORIGIN SOJ IND',
      headerTooltip: 'Origin SOJ Ind',
   },
   {
      field: 'turnAroundSojInd',
      headerName: 'TA SOJ IND',
      headerTooltip: 'Turn Around SOJ Ind',
   },
   {
      field: 'doubleOpenJawInd',
      headerName: 'DOJ IND',
      headerTooltip: 'Double Open Jaw Ind',
   },
   {
      field: 'roundTheWorldInd',
      headerName: 'RTW IND',
      headerTooltip: 'Round the World Ind',
   },
   {
      field: 'jointTransportInd',
      headerName: 'JT IND',
      headerTooltip: 'Joint Transport Ind',
   },
   {
      field: 'inclusiveToursCode',
      headerName: 'INC TOUR',
      headerTooltip: 'Inclusive Tour Code',
   },
   {
      field: 'groupsCode',
      headerName: 'GROUP CODE',
      headerTooltip: 'Group Code',
   },
   {
      field: 'purchaseCode',
      headerName: 'PUR CODE',
      headerTooltip: 'Purchase Code',
   },
   {
      field: 'intermediatePointsInd',
      headerName: 'INTER POINTS',
      headerTooltip: 'Intermediate Points Ind',
   },
   {
      field: 'domIntCode',
      headerName: 'D/I CODE',
      headerTooltip: 'Dom Int Code',
   },
   {
      field: 'noOfSegments',
      headerName: 'SEG NO',
      headerTooltip: 'No. of Segments',
   },
   {
      field: 'ruleApplicationLocalesGeoLocalCode',
      headerName: 'LOCALE CODE',
      headerTooltip: 'Geo Locale Code',
   },
   {
      field: 'ruleApplicationLocalesLocationCode',
      headerName: 'LOC CODE',
      headerTooltip: 'Location Code',
   },
   {
      field: 'ruleApplicationLocalesLocationType',
      headerName: 'LOC TYPE',
      headerTooltip: 'Location Type',
   },
   {
      field: 'addlFareText996Id',
      headerName: 'ADD FARE TEXT ID',
      headerTooltip: 'Additional Fare Text 996 Id',
   },
   {
      field: 'addlFareText996String',
      headerName: 'ADD FARE TEXT',
      headerTooltip: 'Additional Fare Text 996',
      tooltipField: 'addlFareText996String',
      maxWidth: 220,
   },
   {
      field: 'capacityText996Id',
      headerName: 'CAPA TEXT ID',
      headerTooltip: 'Capacity Text 996 Id',
   },
   {
      field: 'capacityText996String',
      headerName: 'CAPA TEXT',
      headerTooltip: 'Capacity Text 996',
      tooltipField: 'capacityText996String',
      maxWidth: 220,
   },
   {
      field: 'notApplText996Id',
      headerName: 'NO APP ID',
      headerTooltip: 'Not Application Text 996 ID',
   },
   {
      field: 'notApplText996String',
      headerName: 'NO APP TEXT',
      headerTooltip: 'Not Applicable Text 996',
      tooltipField: 'notApplText996String',
      maxWidth: 220,
   },
   {
      field: 'otherText996Id',
      headerName: 'OTHER TEXT ID',
      headerTooltip: 'Other Text 996 ID',
   },
   {
      field: 'otherText996String',
      headerName: 'OTHER TEXT',
      headerTooltip: 'Other Text 996',
      tooltipField: 'otherText996String',
      maxWidth: 220,
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
];
export const CATEGORY_04_TABLE_HEADERS = [
   {
      field: 'applicationInd',
      headerName: 'APP IND',
      headerTooltip: 'Application Indicator',
   },
   {
      field: 'flightNumber1',
      headerName: 'FLIGHT NO 1',
      headerTooltip: 'Flight Number 1',
   },
   {
      field: 'carrierCode1',
      headerName: 'CXR CODE 1',
      headerTooltip: 'Carrier Code 1',
   },
   {
      field: 'carrier1FlightTable986Id',
      headerName: 'CXR 1 986 ID',
      headerTooltip: 'Carrier Flight 1 986 Id',
   },
   {
      field: 'cat4Carrier1Flight986Bundled',
      headerName: 'CXR 1 986',
      headerTooltip: 'Carrier Flight 1 986',
   },
   {
      field: 'relationalInd1',
      headerName: 'REL IND 1',
      headerTooltip: 'Relational Ind 1',
   },
   {
      field: 'flightNumber2',
      headerName: 'FLIGHT NO 2',
      headerTooltip: 'Flight Number 2',
   },
   {
      field: 'carrierCode2',
      headerName: 'CXR CODE 2',
      headerTooltip: 'Carrier Code 2',
   },
   {
      field: 'carrier2FlightTable986Id',
      headerName: 'CXR 2 986 ID',
      headerTooltip: 'Carrier Flight 2 986 Id',
   },
    {
        field: 'cat4Carrier2Flight986Bundled',
        headerName: 'CXR 2 986',
        headerTooltip: 'Carrier Flight 2 986',
    },
   {
      field: 'relationalInd2',
      headerName: 'REL IND 2',
      headerTooltip: 'Relational Ind 2',
   },
   {
      field: 'flightNumber3',
      headerName: 'FLIGHT NO 3',
      headerTooltip: 'Flight Number 3',
   },
   {
      field: 'carrierCode3',
      headerName: 'CXR CODE 3',
      headerTooltip: 'Carrier Code 3',
   },
   {
      field: 'dayOfWeekInds',
      headerName: 'DOW IND',
      headerTooltip: 'Day Of Week Indicator',
   },
   {
      field: 'directionalInd',
      headerName: 'DIR IND',
      headerTooltip: 'Directional Ind',
   },
   {
      field: 'locationValidityInd',
      headerName: 'LOC VAL IND',
      headerTooltip: 'Location Validity Ind',
   },
   {
      field: 'locationCodeInd',
      headerName: 'LOC CODE IND',
      headerTooltip: 'Location Code Ind',
   },
   {
      field: 'viaInd',
      headerName: 'VIA IND',
      headerTooltip: 'Via Ind',
   },
   {
      field: 'hiddenInd',
      headerName: 'HID IND',
      headerTooltip: 'Hidden Ind',
   },
   {
      field: 'nonStopInd',
      headerName: 'NON STOP IND',
      headerTooltip: 'Non Stop Ind',
   },
   {
      field: 'directInd',
      headerName: 'DIRECT IND',
      headerTooltip: 'Direct Ind',
   },
   {
      field: 'multiStopInd',
      headerName: 'MUL STOP IND',
      headerTooltip: 'Multi Stop Ind',
   },
   {
      field: 'oneStopInd',
      headerName: 'ONE STOP IND',
      headerTooltip: 'One Stop Ind',
   },
   {
      field: 'interlineConnectInd',
      headerName: 'ONLINE IND',
      headerTooltip: 'Online Connect Ind',
   },
   {
      field: 'onlineConnectInd',
      headerName: 'INTER IND',
      headerTooltip: 'Interline Connect Ind',
   },
   {
      field: 'sameFlightInd',
      headerName: 'SAME IND',
      headerTooltip: 'Same Flight Ind',
   },
   {
      field: 'equipmentCodeInd',
      headerName: 'EQP CODE IND',
      headerTooltip: 'Equipment Code Ind',
   },
   {
      field: 'equipmentCode',
      headerName: 'EQP CODE',
      headerTooltip: 'Equipment Code',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'andTable995Id',
      headerName: 'AND GEO 995',
      headerTooltip: 'And Geographic 995 Id',
   },
   {
      field: 'and995LocationType',
      headerName: 'AND LOCTYP',
      headerTooltip: 'And Geo Location Type',
   },
   {
      field: 'and995Location1Code',
      headerName: 'AND LOC1',
      headerTooltip: 'And Geo Loc1 Code',
   },
   {
      field: 'and995Location2Code',
      headerName: 'AND LOC2',
      headerTooltip: 'And Geo Loc2 Code',
   },
   {
      field: 'and995TravelSegmentIndicator',
      headerName: 'AND TSI',
      headerTooltip: 'And Geo TSI Ind',
   },
   {
      field: 'betweenTable995Id',
      headerName: 'BET Geo 995',
      headerTooltip: 'Between Geographic 995 ID',
   },
   {
      field: 'between995LocationType',
      headerName: 'BET LOCTYP',
      headerTooltip: 'Between Geo Location Type',
   },
   {
      field: 'between995Location1Code',
      headerName: 'BET LOC1',
      headerTooltip: 'Between Geo Loc1 Code',
   },
   {
      field: 'between995Location2Code',
      headerName: 'BET LOC2',
      headerTooltip: 'Between Geo Loc2 Code',
   },
   {
      field: 'between995TravelSegmentIndicator',
      headerName: 'BET TSI',
      headerTooltip: 'Between Geo TSI Ind',
   },
   {
      field: 'viaTable995Id',
      headerName: 'VIA GEO 995',
      headerTooltip: 'Via Geographic 995 Id',
   },
   {
      field: 'via995LocationType',
      headerName: 'VIA LOCTYP',
      headerTooltip: 'Via Geo Location Type',
   },
   {
      field: 'via995Location1Code',
      headerName: 'VIA LOC1',
      headerTooltip: 'Via Geo Loc1 Code',
   },
   {
      field: 'via995Location2Code',
      headerName: 'VIA LOC2',
      headerTooltip: 'Via Geo Loc2 Code',
   },
   {
      field: 'via995TravelSegmentIndicator',
      headerName: 'VIA TSI',
      headerTooltip: 'Via Geo TSI Ind',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'transmissionDateTime',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
   },
];
export const CATEGORY_09_TABLE_HEADERS = [
   {
      field: 'minNumberOfTransfers',
      headerName: 'MIN',
      headerTooltip: 'Min number of transfer',
   },
   {
      field: 'maxNumberOfTransfers',
      headerName: 'MAX',
      headerTooltip: 'Max number of transfer',
   },
   {
      field: 'prmTransferCode',
      headerName: 'PRM',
      headerTooltip: 'Primary transfer code',
   },
   {
      field: 'maxNumberOfPRMTransfers',
      headerName: 'MAX PRM',
      headerTooltip: 'Max primary transfers',
   },
   {
      field: 'smeTransferCode',
      headerName: 'SME',
      headerTooltip: 'Same carrier transfer code',
   },
   {
      field: 'maxNumberOfSMETransfers',
      headerName: 'MAX SME',
      headerTooltip: 'Max same transfer',
   },
   {
      field: 'interlineTransferCode',
      headerName: 'INTERLINE',
      headerTooltip: 'Interline transfer code',
   },
   {
      field: 'maxNumberOfInterlineTransfers',
      headerName: 'MAX INTER',
      headerTooltip: 'Max interline transfer',
   },
   {
      field: 'otherCarrierTransferCode',
      headerName: 'OTH CXR',
      headerTooltip: 'Other Carrier transfer code',
   },
   {
      field: 'maxNumberOfOtherCarrierTransfers',
      headerName: 'MAX OTH CXR',
      headerTooltip: 'Max other carrier transfer',
   },
   {
      field: 'outboundTransfersPermitted',
      headerName: 'OUT',
      headerTooltip: 'Outbound Transfers',
   },
   {
      field: 'inboundTransfersPermitted',
      headerName: 'IN',
      headerTooltip: 'Inbound Transfers',
   },
   {
      field: 'outboundOrReturnPermitCode',
      headerName: 'OR',
      headerTooltip: 'Outbound return permit',
   },
   {
      field: 'surfTag',
      headerName: 'SURF TAG',
      headerTooltip: 'Surface Tag',
   },
   {
      field: 'surfTable976Id',
      headerName: 'SURF 976 ID',
      headerTooltip: 'Surface table 976 Id',
   },
   {
      field: 'embTag',
      headerName: 'EMB TAG',
      headerTooltip: 'Embedded Surface Tag',
   },
   {
      field: 'embeddedSurfTable976Id',
      headerName: 'EMB 976 ID',
      headerTooltip: 'Embedded Table 976 Id',
   },
   {
      field: 'transferChargesIndicator',
      headerName: 'APPL',
      headerTooltip: 'Transfer Charges Ind',
   },
   {
      field: 'maxTransfersAssessed',
      headerName: 'CHARGE 1 NO',
      headerTooltip: 'Max Transfer Assess',
   },
   {
      field: 'charge1',
      headerName: 'CHARGE 1 AMT',
      headerTooltip: 'Charge 1',
   },
   {
      field: 'maxTransfersCharged',
      headerName: 'CHARGE 2 NO',
      headerTooltip: 'Max Transfer Charge',
   },
   {
      field: 'charge2',
      headerName: 'CHARGE 2 AMT',
      headerTooltip: 'Charge 2',
   },
   {
      field: 'currencyCode1',
      headerName: 'CURR 1',
      headerTooltip: 'Currency 1 Code',
   },
   {
      field: 'decimalPlace1',
      headerName: 'DEC NO 1',
      headerTooltip: 'Decimal Place 1',
   },
   {
      field: 'charge3',
      headerName: 'CHARGE 3 AMT',
      headerTooltip: 'Charge 3',
   },
   {
      field: 'charge4',
      headerName: 'CHARGE 4 AMT',
      headerTooltip: 'Charge 4',
   },
   {
      field: 'currencyCode2',
      headerName: 'CCURR 2',
      headerTooltip: 'Currency 2 Code',
   },
   {
      field: 'decimalPlace2',
      headerName: 'DEC NO 2',
      headerTooltip: 'Decimal Place 2',
   },
   {
      field: 'numberOfSegments',
      headerName: 'NO OF SEGS',
      headerTooltip: 'No of Segments',
   },
   {
      field: 'transferSegmentsTransferApplication',
      headerName: 'TRAN APPL',
      headerTooltip: 'Transfer Application',
   },
   {
      field: 'transferSegmentsTransferNumber',
      headerName: 'NUM',
      headerTooltip: 'Transfer Number',
   },
   {
      field: 'transferSegmentsTransferPrm',
      headerName: 'PRIMARY',
      headerTooltip: 'Transfer Primary',
   },
   {
      field: 'transferSegmentsTransferSme',
      headerName: 'T SME',
      headerTooltip: 'Transfer Same Carrier',
   },
   {
      field: 'transferSegmentsTransferPrmOth',
      headerName: 'T OTH CXR',
      headerTooltip: 'Transfer Other Carrier',
   },
   {
      field: 'transferSegmentsTransferInterline',
      headerName: 'T INTERLINE',
      headerTooltip: 'Transfer Interline',
   },
   {
      field: 'transferSegmentsConnectionOrStopoverPoint',
      headerName: 'CNX OR STOP',
      headerTooltip: 'Connection or Stopover',
   },
   {
      field: 'transferSegmentsCarrierApplicationCode',
      headerName: 'CXR APP CODE',
      headerTooltip: 'Carrier App Code',
   },
   {
      field: 'transferSegmentsInCarrierCode',
      headerName: 'IN CXR CODE',
      headerTooltip: 'In Carrier Code',
   },
   {
      field: 'transferSegmentsInCarrierTable990Id',
      headerName: 'IN CXR 990 ID',
      headerTooltip: 'In carrier 990 Id',
   },
   {
      field: 'transferSegmentsOutCarrierCode',
      headerName: 'OUT CXR CODE',
      headerTooltip: 'Out Carrier Code',
   },
   {
      field: 'transferSegmentsOutCarrierTable990Id',
      headerName: 'OUT CXR 990 ID',
      headerTooltip: 'Out carrier 990 Id',
   },
   {
      field: 'transferSegmentsTravelSegmentIndicator',
      headerName: 'TSI',
      headerTooltip: 'Travel Segment Indicator',
   },
   {
      field: 'transferSegmentsTypeCode',
      headerName: 'TYPE CODE',
      headerTooltip: 'Type Code',
   },
   {
      field: 'transferSegmentsLocation1Code',
      headerName: 'LOC 1 CODE',
      headerTooltip: 'Location 1 code',
   },
   {
      field: 'transferSegmentsLocation2Code',
      headerName: 'LOC 2 CODE',
      headerTooltip: 'Location 2 code',
   },
   {
      field: 'transferSegmentsLocation1Zone978Id',
      headerName: 'LOC 978 ID',
      headerTooltip: 'Location Zone 978 Id',
   },
   {
      field: 'transferSegmentsBetween',
      headerName: 'BET LOC',
      headerTooltip: 'Between Location',
   },
   {
      field: 'transferSegmentsGateway',
      headerName: 'GATEWAY',
      headerTooltip: 'Gateway',
   },
   {
      field: 'transferSegmentsRestriction',
      headerName: 'RESTRICTION',
      headerTooltip: 'Restriction',
   },
   {
      field: 'transferSegmentsPortionIndicator',
      headerName: 'POR IND',
      headerTooltip: 'Portion Indicator',
   },
   {
      field: 'transferSegmentsTransferCharge',
      headerName: 'TRANSFER',
      headerTooltip: 'Transfer Charge',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'transmissionDateTime',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
   },
];
export const CATEGORY_18_TABLE_HEADERS = [
   {
      field: 'text',
      headerName: 'TICKET TEXT',
      headerTooltip: 'Ticket Text',
   },
   {
      field: 'locationCode',
      headerName: 'LOC CODE',
      headerTooltip: 'Location Code',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date',
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'transmissionDateTime',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
   },
];
export const CATEGORY_19_TABLE_HEADERS = [
   {
      field: 'noDiscountInd',
      headerName: 'NO DISC IND',
      headerTooltip: 'No Discount Ind',
   },
   {
      field: 'passengerTypeCode',
      headerName: 'PTC',
      headerTooltip: 'Passenger Type Code',
   },
   {
      field: 'idRequirementInd',
      headerName: 'ID REQ IND',
      headerTooltip: 'Id Required Indicator',
   },
   {
      field: 'minimumAge',
      headerName: 'MIN AGE',
      headerTooltip: 'Minimum Age',
   },
   {
      field: 'maximumAge',
      headerName: 'MAX AGE',
      headerTooltip: 'Maximum Age',
   },
   {
      field: 'firstTravelOccurrence',
      headerName: 'FIRST TVL',
      headerTooltip: 'First travel occur',
   },
   {
      field: 'lastTravelOccurrence',
      headerName: 'LAST TVL',
      headerTooltip: 'Last travel occur',
   },
   {
      field: 'fareInd',
      headerName: 'FARE IND',
      headerTooltip: 'Fare Ind',
   },
   {
      field: 'percentApplication',
      headerName: 'PERCENT APP',
      headerTooltip: 'Percent Application',
   },
   {
      field: 'owRtInd',
      headerName: 'OWRT',
      headerTooltip: 'OW/RT Indicator',
   },
   {
      field: 'baseFareType',
      headerName: 'FARE TYPE',
      headerTooltip: 'Base Fare Type',
   },
   {
      field: 'baseFareApplication',
      headerName: 'FARE APP',
      headerTooltip: 'Base Fare App',
   },
   {
      field: 'bookingApplicationInd',
      headerName: 'BOOK APP IND',
      headerTooltip: 'Booking App Ind',
   },
   {
      field: 'bookingCode',
      headerName: 'BOOK CODE',
      headerTooltip: 'Booking Code',
   },
   {
      field: 'betweenCityCode',
      headerName: 'BET CITY CODE',
      headerTooltip: 'Between City Code',
   },
   {
      field: 'andCityCode',
      headerName: 'AND CITY CODE',
      headerTooltip: 'And City Code',
   },
   {
      field: 'specifiedFare1',
      headerName: 'SPEC FARE 1',
      headerTooltip: 'Specified Fare 1',
   },
   {
      field: 'currency1Code',
      headerName: 'CURR 1',
      headerTooltip: 'Currency 1 Code',
   },
   {
      field: 'decimal1Number',
      headerName: 'DEC 1',
      headerTooltip: 'Decimal 1',
   },
   {
      field: 'specifiedFare2',
      headerName: 'SPEC FARE 2',
      headerTooltip: 'Specified Fare 2',
   },
   {
      field: 'currency2Code',
      headerName: 'CURR 2',
      headerTooltip: 'Currency 2 Code',
   },
   {
      field: 'decimal2Number',
      headerName: 'DEC 2',
      headerTooltip: 'Decimal 2',
   },
   {
      field: 'resultingOwRtInd',
      headerName: 'RES OWRT',
      headerTooltip: 'Resulting OwRt',
   },
   {
      field: 'resultingFareClass',
      headerName: 'RES FCC',
      headerTooltip: 'Resulting Fare Class',
   },
   {
      field: 'resultingBookingCode',
      headerName: 'RES BC',
      headerTooltip: 'Resulting Booking Code',
   },
   {
      field: 'ticketingCode',
      headerName: 'TKT CODE',
      headerTooltip: 'Ticketing Code',
   },
   {
      field: 'ticketingCodeModifier',
      headerName: 'TKT CODE MOD',
      headerTooltip: 'Ticketing Code Modifier',
   },
   {
      field: 'ticketDesignator',
      headerName: 'TKT DES',
      headerTooltip: 'Ticket Designator',
   },
   {
      field: 'ticketDesignatorModifier',
      headerName: 'TKT DES MOD',
      headerTooltip: 'Ticket designator modifier',
   },
   {
      field: 'allSectorsInd',
      headerName: 'ALL SEC IND',
      headerTooltip: 'All Sectors Ind',
   },
   {
      field: 'outboundJourneyInd',
      headerName: 'OUT IND',
      headerTooltip: 'Outbound Ind',
   },
   {
      field: 'atLeastOneSectorInd',
      headerName: 'ONE SEC IND',
      headerTooltip: 'Atleast One Sector Ind',
   },
   {
      field: 'sameCompartmentInd',
      headerName: 'SAME COMP',
      headerTooltip: 'Same Compartment',
   },
   {
      field: 'sameRuleInd',
      headerName: 'SAME RULE',
      headerTooltip: 'Same Rule Ind',
   },
   {
      field: 'accompanyingPassengerInd',
      headerName: 'ACC PASS',
      headerTooltip: 'Acc Passenger',
   },
   {
      field: 'fareBookingInd',
      headerName: 'FARE BOOK IND',
      headerTooltip: 'Fare Booking Ind',
   },
   {
      field: 'endOfRecordInd',
      headerName: 'EOD',
      headerTooltip: 'End Of Record',
   },
   {
      field: 'noOfSegments',
      headerName: 'NO OF SEG',
      headerTooltip: 'No of Segments',
   },
   {
      field: 'accompanyingPassengersMinNumber',
      headerName: 'S. MIN NO PASS',
      headerTooltip: 'Segment Min No of Passenger',
   },
   {
      field: 'accompanyingPassengersMaxNumber',
      headerName: 'S. MAX NO PASS',
      headerTooltip: 'Segment Max No of Passenger',
   },
   {
      field: 'accompanyingPassengersPassengerTypeCode',
      headerName: 'S. PTC',
      headerTooltip: 'Segment Passenger Type Code',
   },
   {
      field: 'accompanyingPassengersMaxAge',
      headerName: 'S. MAX AGE',
      headerTooltip: 'Segment Maximum Age',
   },
   {
      field: 'accompanyingPassengersMinAge',
      headerName: 'S. MIN AGE',
      headerTooltip: 'Segment Minimum Age',
   },
   {
      field: 'accompanyingPassengersFareClassCode',
      headerName: 'S. FCC',
      headerTooltip: 'Segment Fare Class Code',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'geographic995Id',
      headerName: 'GEO 995',
      headerTooltip: 'Geographic 995 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'geo995LocationType',
      headerName: 'LOCTYP 995',
      headerTooltip: 'Geo Location Type',
   },
   {
      field: 'geo995Location1Code',
      headerName: 'LOC1 995',
      headerTooltip: 'Geo Loc1 Code',
   },
   {
      field: 'geo995Location2Code',
      headerName: 'LOC2 995',
      headerTooltip: 'Geo Loc2 Code',
   },
   {
      field: 'geo995TravelSegmentIndicator',
      headerName: 'TSI 995',
      headerTooltip: 'Geo 995 TSI Ind',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
];
export const CATEGORY_20_TABLE_HEADERS = [
   {
      field: 'noDiscountInd',
      headerName: 'NO DISC IND',
      headerTooltip: 'No Discount Ind',
   },
   {
      field: 'passengerTypeCode',
      headerName: 'PTC',
      headerTooltip: 'Passenger Type Code',
   },
   {
      field: 'idRequirementInd',
      headerName: 'ID REQ IND',
      headerTooltip: 'Id Required Indicator',
   },
   {
      field: 'minimumAge',
      headerName: 'MIN AGE',
      headerTooltip: 'Minimum Age',
   },
   {
      field: 'maximumAge',
      headerName: 'MAX AGE',
      headerTooltip: 'Maximum Age',
   },
   {
      field: 'firstTravelOccurrence',
      headerName: 'FIRST TVL',
      headerTooltip: 'First travel occur',
   },
   {
      field: 'lastTravelOccurrence',
      headerName: 'LAST TVL',
      headerTooltip: 'Last travel occur',
   },
   {
      field: 'fareInd',
      headerName: 'FARE IND',
      headerTooltip: 'Fare Ind',
   },
   {
      field: 'percentApplication',
      headerName: 'PERCENT APP',
      headerTooltip: 'Percent Application',
   },
   {
      field: 'owRtInd',
      headerName: 'OWRT',
      headerTooltip: 'OW/RT Indicator',
   },
   {
      field: 'baseFareType',
      headerName: 'FARE TYPE',
      headerTooltip: 'Base Fare Type',
   },
   {
      field: 'baseFareApplication',
      headerName: 'FARE APP',
      headerTooltip: 'Base Fare App',
   },
   {
      field: 'bookingApplicationInd',
      headerName: 'BOOK APP IND',
      headerTooltip: 'Booking App Ind',
   },
   {
      field: 'bookingCode',
      headerName: 'BOOK CODE',
      headerTooltip: 'Booking Code',
   },
   {
      field: 'betweenCityCode',
      headerName: 'BET CITY CODE',
      headerTooltip: 'Between City Code',
   },
   {
      field: 'andCityCode',
      headerName: 'AND CITY CODE',
      headerTooltip: 'And City Code',
   },
   {
      field: 'specifiedFare1',
      headerName: 'SPEC FARE 1',
      headerTooltip: 'Specified Fare 1',
   },
   {
      field: 'currency1Code',
      headerName: 'CURR 1',
      headerTooltip: 'Currency 1 Code',
   },
   {
      field: 'decimal1Number',
      headerName: 'DEC 1',
      headerTooltip: 'Decimal 1',
   },
   {
      field: 'specifiedFare2',
      headerName: 'SPEC FARE 2',
      headerTooltip: 'Specified Fare 2',
   },
   {
      field: 'currency2Code',
      headerName: 'CURR 2',
      headerTooltip: 'Currency 2 Code',
   },
   {
      field: 'decimal2Number',
      headerName: 'DEC 2',
      headerTooltip: 'Decimal 2',
   },
   {
      field: 'resultingOwRtInd',
      headerName: 'RES OWRT',
      headerTooltip: 'Resulting OwRt',
   },
   {
      field: 'resultingFareClass',
      headerName: 'RES FCC',
      headerTooltip: 'Resulting Fare Class',
   },
   {
      field: 'resultingBookingCode',
      headerName: 'RES BC',
      headerTooltip: 'Resulting Booking Code',
   },
   {
      field: 'ticketingCode',
      headerName: 'TKT CODE',
      headerTooltip: 'Ticketing Code',
   },
   {
      field: 'ticketingCodeModifier',
      headerName: 'TKT CODE MOD',
      headerTooltip: 'Ticketing Code Modifier',
   },
   {
      field: 'ticketDesignator',
      headerName: 'TKT DES',
      headerTooltip: 'Ticket Designator',
   },
   {
      field: 'ticketDesignatorModifier',
      headerName: 'TKT DES MOD',
      headerTooltip: 'Ticket designator modifier',
   },
   {
      field: 'allSectorsInd',
      headerName: 'ALL SEC IND',
      headerTooltip: 'All Sectors Ind',
   },
   {
      field: 'outboundJourneyInd',
      headerName: 'OUT IND',
      headerTooltip: 'Outbound Ind',
   },
   {
      field: 'atLeastOneSectorInd',
      headerName: 'ONE SEC IND',
      headerTooltip: 'Atleast One Sector Ind',
   },
   {
      field: 'sameCompartmentInd',
      headerName: 'SAME COMP',
      headerTooltip: 'Same Compartment',
   },
   {
      field: 'sameRuleInd',
      headerName: 'SAME RULE',
      headerTooltip: 'Same Rule Ind',
   },
   {
      field: 'accompanyingPassengerInd',
      headerName: 'ACC PASS',
      headerTooltip: 'Acc Passenger',
   },
   {
      field: 'fareBookingInd',
      headerName: 'FARE BOOK IND',
      headerTooltip: 'Fare Booking Ind',
   },
   {
      field: 'endOfRecordInd',
      headerName: 'EOD',
      headerTooltip: 'End Of Record',
   },
   {
      field: 'noOfSegments',
      headerName: 'NO OF SEG',
      headerTooltip: 'No of Segments',
   },
   {
      field: 'accompanyingPassengersMinNumber',
      headerName: 'S. MIN NO PASS',
      headerTooltip: 'Segment Min No of Passenger',
   },
   {
      field: 'accompanyingPassengersMaxNumber',
      headerName: 'S. MAX NO PASS',
      headerTooltip: 'Segment Max No of Passenger',
   },
   {
      field: 'accompanyingPassengersPassengerTypeCode',
      headerName: 'S. PTC',
      headerTooltip: 'Segment Passenger Type Code',
   },
   {
      field: 'accompanyingPassengersMaxAge',
      headerName: 'S. MAX AGE',
      headerTooltip: 'Segment Maximum Age',
   },
   {
      field: 'accompanyingPassengersMinAge',
      headerName: 'S. MIN AGE',
      headerTooltip: 'Segment Minimum Age',
   },
   {
      field: 'accompanyingPassengersFareClassCode',
      headerName: 'S. FCC',
      headerTooltip: 'Segment Fare Class Code',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'geographic995Id',
      headerName: 'GEO 995',
      headerTooltip: 'Geographic 995 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'geo995LocationType',
      headerName: 'LOCTYP 995',
      headerTooltip: 'Geo Location Type',
   },
   {
      field: 'geo995Location1Code',
      headerName: 'LOC1 995',
      headerTooltip: 'Geo Loc1 Code',
   },
   {
      field: 'geo995Location2Code',
      headerName: 'LOC2 995',
      headerTooltip: 'Geo Loc2 Code',
   },
   {
      field: 'geo995TravelSegmentIndicator',
      headerName: 'TSI 995',
      headerTooltip: 'Geo 995 TSI Ind',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
];
export const CATEGORY_21_TABLE_HEADERS = [
   {
      field: 'noDiscountInd',
      headerName: 'NO DISC IND',
      headerTooltip: 'No Discount Ind',
   },
   {
      field: 'passengerTypeCode',
      headerName: 'PTC',
      headerTooltip: 'Passenger Type Code',
   },
   {
      field: 'idRequirementInd',
      headerName: 'ID REQ IND',
      headerTooltip: 'Id Required Indicator',
   },
   {
      field: 'minimumAge',
      headerName: 'MIN AGE',
      headerTooltip: 'Minimum Age',
   },
   {
      field: 'maximumAge',
      headerName: 'MAX AGE',
      headerTooltip: 'Maximum Age',
   },
   {
      field: 'firstTravelOccurrence',
      headerName: 'FIRST TVL',
      headerTooltip: 'First travel occur',
   },
   {
      field: 'lastTravelOccurrence',
      headerName: 'LAST TVL',
      headerTooltip: 'Last travel occur',
   },
   {
      field: 'fareInd',
      headerName: 'FARE IND',
      headerTooltip: 'Fare Ind',
   },
   {
      field: 'percentApplication',
      headerName: 'PERCENT APP',
      headerTooltip: 'Percent Application',
   },
   {
      field: 'owRtInd',
      headerName: 'OWRT',
      headerTooltip: 'OW/RT Indicator',
   },
   {
      field: 'baseFareType',
      headerName: 'FARE TYPE',
      headerTooltip: 'Base Fare Type',
   },
   {
      field: 'baseFareApplication',
      headerName: 'FARE APP',
      headerTooltip: 'Base Fare App',
   },
   {
      field: 'bookingApplicationInd',
      headerName: 'BOOK APP IND',
      headerTooltip: 'Booking App Ind',
   },
   {
      field: 'bookingCode',
      headerName: 'BOOK CODE',
      headerTooltip: 'Booking Code',
   },
   {
      field: 'betweenCityCode',
      headerName: 'BET CITY CODE',
      headerTooltip: 'Between City Code',
   },
   {
      field: 'andCityCode',
      headerName: 'AND CITY CODE',
      headerTooltip: 'And City Code',
   },
   {
      field: 'specifiedFare1',
      headerName: 'SPEC FARE 1',
      headerTooltip: 'Specified Fare 1',
   },
   {
      field: 'currency1Code',
      headerName: 'CURR 1',
      headerTooltip: 'Currency 1 Code',
   },
   {
      field: 'decimal1Number',
      headerName: 'DEC 1',
      headerTooltip: 'Decimal 1',
   },
   {
      field: 'specifiedFare2',
      headerName: 'SPEC FARE 2',
      headerTooltip: 'Specified Fare 2',
   },
   {
      field: 'currency2Code',
      headerName: 'CURR 2',
      headerTooltip: 'Currency 2 Code',
   },
   {
      field: 'decimal2Number',
      headerName: 'DEC 2',
      headerTooltip: 'Decimal 2',
   },
   {
      field: 'resultingOwRtInd',
      headerName: 'RES OWRT',
      headerTooltip: 'Resulting OwRt',
   },
   {
      field: 'resultingFareClass',
      headerName: 'RES FCC',
      headerTooltip: 'Resulting Fare Class',
   },
   {
      field: 'resultingBookingCode',
      headerName: 'RES BC',
      headerTooltip: 'Resulting Booking Code',
   },
   {
      field: 'ticketingCode',
      headerName: 'TKT CODE',
      headerTooltip: 'Ticketing Code',
   },
   {
      field: 'ticketingCodeModifier',
      headerName: 'TKT CODE MOD',
      headerTooltip: 'Ticketing Code Modifier',
   },
   {
      field: 'ticketDesignator',
      headerName: 'TKT DES',
      headerTooltip: 'Ticket Designator',
   },
   {
      field: 'ticketDesignatorModifier',
      headerName: 'TKT DES MOD',
      headerTooltip: 'Ticket designator modifier',
   },
   {
      field: 'allSectorsInd',
      headerName: 'ALL SEC IND',
      headerTooltip: 'All Sectors Ind',
   },
   {
      field: 'outboundJourneyInd',
      headerName: 'OUT IND',
      headerTooltip: 'Outbound Ind',
   },
   {
      field: 'atLeastOneSectorInd',
      headerName: 'ONE SEC IND',
      headerTooltip: 'Atleast One Sector Ind',
   },
   {
      field: 'sameCompartmentInd',
      headerName: 'SAME COMP',
      headerTooltip: 'Same Compartment',
   },
   {
      field: 'sameRuleInd',
      headerName: 'SAME RULE',
      headerTooltip: 'Same Rule Ind',
   },
   {
      field: 'accompanyingPassengerInd',
      headerName: 'ACC PASS',
      headerTooltip: 'Acc Passenger',
   },
   {
      field: 'fareBookingInd',
      headerName: 'FARE BOOK IND',
      headerTooltip: 'Fare Booking Ind',
   },
   {
      field: 'endOfRecordInd',
      headerName: 'EOD',
      headerTooltip: 'End Of Record',
   },
   {
      field: 'noOfSegments',
      headerName: 'NO OF SEG',
      headerTooltip: 'No of Segments',
   },
   {
      field: 'accompanyingPassengersMinNumber',
      headerName: 'S. MIN NO PASS',
      headerTooltip: 'Segment Min No of Passenger',
   },
   {
      field: 'accompanyingPassengersMaxNumber',
      headerName: 'S. MAX NO PASS',
      headerTooltip: 'Segment Max No of Passenger',
   },
   {
      field: 'accompanyingPassengersPassengerTypeCode',
      headerName: 'S. PTC',
      headerTooltip: 'Segment Passenger Type Code',
   },
   {
      field: 'accompanyingPassengersMaxAge',
      headerName: 'S. MAX AGE',
      headerTooltip: 'Segment Maximum Age',
   },
   {
      field: 'accompanyingPassengersMinAge',
      headerName: 'S. MIN AGE',
      headerTooltip: 'Segment Minimum Age',
   },
   {
      field: 'accompanyingPassengersFareClassCode',
      headerName: 'S. FCC',
      headerTooltip: 'Segment Fare Class Code',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'geographic995Id',
      headerName: 'GEO 995',
      headerTooltip: 'Geographic 995 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'geo995LocationType',
      headerName: 'LOCTYP 995',
      headerTooltip: 'Geo Location Type',
   },
   {
      field: 'geo995Location1Code',
      headerName: 'LOC1 995',
      headerTooltip: 'Geo Loc1 Code',
   },
   {
      field: 'geo995Location2Code',
      headerName: 'LOC2 995',
      headerTooltip: 'Geo Loc2 Code',
   },
   {
      field: 'geo995TravelSegmentIndicator',
      headerName: 'TSI 995',
      headerTooltip: 'Geo 995 TSI Ind',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
];
export const CATEGORY_22_TABLE_HEADERS = [
   {
      field: 'noDiscountInd',
      headerName: 'NO DISC IND',
      headerTooltip: 'No Discount Ind',
   },
   {
      field: 'passengerTypeCode',
      headerName: 'PTC',
      headerTooltip: 'Passenger Type Code',
   },
   {
      field: 'idRequirementInd',
      headerName: 'ID REQ IND',
      headerTooltip: 'Id Required Indicator',
   },
   {
      field: 'minimumAge',
      headerName: 'MIN AGE',
      headerTooltip: 'Minimum Age',
   },
   {
      field: 'maximumAge',
      headerName: 'MAX AGE',
      headerTooltip: 'Maximum Age',
   },
   {
      field: 'firstTravelOccurrence',
      headerName: 'FIRST TVL',
      headerTooltip: 'First travel occur',
   },
   {
      field: 'lastTravelOccurrence',
      headerName: 'LAST TVL',
      headerTooltip: 'Last travel occur',
   },
   {
      field: 'fareInd',
      headerName: 'FARE IND',
      headerTooltip: 'Fare Ind',
   },
   {
      field: 'percentApplication',
      headerName: 'PERCENT APP',
      headerTooltip: 'Percent Application',
   },
   {
      field: 'owRtInd',
      headerName: 'OWRT',
      headerTooltip: 'OW/RT Indicator',
   },
   {
      field: 'baseFareType',
      headerName: 'FARE TYPE',
      headerTooltip: 'Base Fare Type',
   },
   {
      field: 'baseFareApplication',
      headerName: 'FARE APP',
      headerTooltip: 'Base Fare App',
   },
   {
      field: 'bookingApplicationInd',
      headerName: 'BOOK APP IND',
      headerTooltip: 'Booking App Ind',
   },
   {
      field: 'bookingCode',
      headerName: 'BOOK CODE',
      headerTooltip: 'Booking Code',
   },
   {
      field: 'betweenCityCode',
      headerName: 'BET CITY CODE',
      headerTooltip: 'Between City Code',
   },
   {
      field: 'andCityCode',
      headerName: 'AND CITY CODE',
      headerTooltip: 'And City Code',
   },
   {
      field: 'specifiedFare1',
      headerName: 'SPEC FARE 1',
      headerTooltip: 'Specified Fare 1',
   },
   {
      field: 'currency1Code',
      headerName: 'CURR 1',
      headerTooltip: 'Currency 1 Code',
   },
   {
      field: 'decimal1Number',
      headerName: 'DEC 1',
      headerTooltip: 'Decimal 1',
   },
   {
      field: 'specifiedFare2',
      headerName: 'SPEC FARE 2',
      headerTooltip: 'Specified Fare 2',
   },
   {
      field: 'currency2Code',
      headerName: 'CURR 2',
      headerTooltip: 'Currency 2 Code',
   },
   {
      field: 'decimal2Number',
      headerName: 'DEC 2',
      headerTooltip: 'Decimal 2',
   },
   {
      field: 'resultingOwRtInd',
      headerName: 'RES OWRT',
      headerTooltip: 'Resulting OwRt',
   },
   {
      field: 'resultingFareClass',
      headerName: 'RES FCC',
      headerTooltip: 'Resulting Fare Class',
   },
   {
      field: 'resultingBookingCode',
      headerName: 'RES BC',
      headerTooltip: 'Resulting Booking Code',
   },
   {
      field: 'ticketingCode',
      headerName: 'TKT CODE',
      headerTooltip: 'Ticketing Code',
   },
   {
      field: 'ticketingCodeModifier',
      headerName: 'TKT CODE MOD',
      headerTooltip: 'Ticketing Code Modifier',
   },
   {
      field: 'ticketDesignator',
      headerName: 'TKT DES',
      headerTooltip: 'Ticket Designator',
   },
   {
      field: 'ticketDesignatorModifier',
      headerName: 'TKT DES MOD',
      headerTooltip: 'Ticket designator modifier',
   },
   {
      field: 'allSectorsInd',
      headerName: 'ALL SEC IND',
      headerTooltip: 'All Sectors Ind',
   },
   {
      field: 'outboundJourneyInd',
      headerName: 'OUT IND',
      headerTooltip: 'Outbound Ind',
   },
   {
      field: 'atLeastOneSectorInd',
      headerName: 'ONE SEC IND',
      headerTooltip: 'Atleast One Sector Ind',
   },
   {
      field: 'sameCompartmentInd',
      headerName: 'SAME COMP',
      headerTooltip: 'Same Compartment',
   },
   {
      field: 'sameRuleInd',
      headerName: 'SAME RULE',
      headerTooltip: 'Same Rule Ind',
   },
   {
      field: 'accompanyingPassengerInd',
      headerName: 'ACC PASS',
      headerTooltip: 'Acc Passenger',
   },
   {
      field: 'fareBookingInd',
      headerName: 'FARE BOOK IND',
      headerTooltip: 'Fare Booking Ind',
   },
   {
      field: 'endOfRecordInd',
      headerName: 'EOD',
      headerTooltip: 'End Of Record',
   },
   {
      field: 'noOfSegments',
      headerName: 'NO OF SEG',
      headerTooltip: 'No of Segments',
   },
   {
      field: 'accompanyingPassengersMinNumber',
      headerName: 'S. MIN NO PASS',
      headerTooltip: 'Segment Min No of Passenger',
   },
   {
      field: 'accompanyingPassengersMaxNumber',
      headerName: 'S. MAX NO PASS',
      headerTooltip: 'Segment Max No of Passenger',
   },
   {
      field: 'accompanyingPassengersPassengerTypeCode',
      headerName: 'S. PTC',
      headerTooltip: 'Segment Passenger Type Code',
   },
   {
      field: 'accompanyingPassengersMaxAge',
      headerName: 'S. MAX AGE',
      headerTooltip: 'Segment Maximum Age',
   },
   {
      field: 'accompanyingPassengersMinAge',
      headerName: 'S. MIN AGE',
      headerTooltip: 'Segment Minimum Age',
   },
   {
      field: 'accompanyingPassengersFareClassCode',
      headerName: 'S. FCC',
      headerTooltip: 'Segment Fare Class Code',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'geographic995Id',
      headerName: 'GEO 995',
      headerTooltip: 'Geographic 995 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'geo995LocationType',
      headerName: 'LOCTYP 995',
      headerTooltip: 'Geo Location Type',
   },
   {
      field: 'geo995Location1Code',
      headerName: 'LOC1 995',
      headerTooltip: 'Geo Loc1 Code',
   },
   {
      field: 'geo995Location2Code',
      headerName: 'LOC2 995',
      headerTooltip: 'Geo Loc2 Code',
   },
   {
      field: 'geo995TravelSegmentIndicator',
      headerName: 'TSI 995',
      headerTooltip: 'Geo 995 TSI Ind',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'receivedDateString',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
      valueFormatter: (params) => params?.value?.slice(0, 13),
   },
];
export const CATEGORY_23_TABLE_HEADERS = [
   {
      field: 'constructionFareCode',
      headerName: 'CON IND',
      headerTooltip: 'Construction Ind',
   },
   {
      field: 'prorateCode',
      headerName: 'PRO IND',
      headerTooltip: 'Prorate Ind',
   },
   {
      field: 'differentialCode',
      headerName: 'DIFF IND',
      headerTooltip: 'Differential Code Ind',
   },
   {
      field: 'proportionalInd',
      headerName: 'EXT IND',
      headerTooltip: 'Extension Fare Ind',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'transmissionDateTime',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
   },
];
export const CATEGORY_26_TABLE_HEADERS = [
   {
      field: 'groupType',
      headerName: 'GROUP TYPE',
      headerTooltip: 'Group Type',
   },
   {
      field: 'minGroupSize',
      headerName: 'MIN GRP',
      headerTooltip: 'Minimum Group Size',
   },
   {
      field: 'maxGroupSize',
      headerName: 'MAX GRP',
      headerTooltip: 'Maximum Group Size',
   },
   {
      field: 'fareClassType',
      headerName: 'FARE CLASS',
      headerTooltip: 'Fare Class Type',
   },
   {
      field: 'flightNumber',
      headerName: 'FLIGHT NO',
      headerTooltip: 'Flight Number',
   },
   {
      field: 'validityIndicator',
      headerName: 'VAL IND',
      headerTooltip: 'Validity Ind',
   },
   {
      field: 'applicationType',
      headerName: 'APP TYPE',
      headerTooltip: 'Application Type',
   },
   {
      field: 'numberOfChildren',
      headerName: 'NO OF CHILD',
      headerTooltip: 'Number of Children',
   },
   {
      field: 'childFarePercentage',
      headerName: 'CH PERCENT',
      headerTooltip: 'Child Fare Percentage',
   },
   {
      field: 'fareClassCode',
      headerName: 'FCC',
      headerTooltip: 'Fare Class Code',
   },
   {
      field: 'childFareType',
      headerName: 'CH FARE TYPE',
      headerTooltip: 'Child Fare Type',
   },
   {
      field: 'reqType',
      headerName: 'NM REQ TYPE',
      headerTooltip: 'Name Req Type',
   },
   {
      field: 'timeOfDay',
      headerName: 'TOD',
      headerTooltip: 'Time Of day',
   },
   {
      field: 'namePeriod',
      headerName: 'NM PERIOD',
      headerTooltip: 'Name Period',
   },
   {
      field: 'nameUnit',
      headerName: 'NM UNIT',
      headerTooltip: 'Name Unit',
   },
   {
      field: 'nameApplCode',
      headerName: 'NM APP CODE',
      headerTooltip: 'Name Appl Code',
   },
   {
      field: 'itinerary',
      headerName: 'ITI',
      headerTooltip: 'Itinerary',
   },
   {
      field: 'pnr',
      headerName: 'PNR',
      headerTooltip: 'PNR',
   },
   {
      field: 'fareCode',
      headerName: 'FARE CODE',
      headerTooltip: 'Special Fare Code',
   },
   {
      field: 'additionalPassengers',
      headerName: 'ADD PASS NO',
      headerTooltip: 'Additional Passenger No',
   },
   {
      field: 'totalGroupPercent',
      headerName: 'GR PERCENT',
      headerTooltip: 'Group Percentage',
   },
   {
      field: 'departTimeOfDay',
      headerName: 'DE TOD',
      headerTooltip: 'Depart Time of day',
   },
   {
      field: 'elapsedTimePeriod',
      headerName: 'EL TIME P',
      headerTooltip: 'Elapsed Time Period',
   },
   {
      field: 'precedingPeriod',
      headerName: 'EL TIME U',
      headerTooltip: 'Elapsed Time Unit',
   },
   {
      field: 'ticketingTimeOfDay',
      headerName: 'TKT TOD',
      headerTooltip: 'Ticketing time of day',
   },
   {
      field: 'additionalPeriod',
      headerName: 'ADD TIME P',
      headerTooltip: 'Additional Time Period',
   },
   {
      field: 'unit1',
      headerName: 'ADD TIME U',
      headerTooltip: 'Additional Time Unit',
   },
   {
      field: 'imm1',
      headerName: 'TKT IMM',
      headerTooltip: 'Ticketed Immediately',
   },
   {
      field: 'maxSubstitutePassengers',
      headerName: 'SUB PASS NO',
      headerTooltip: 'No of Substituted Passenger',
   },
   {
      field: 'maxPercent',
      headerName: 'MAX PERCENT',
      headerTooltip: 'Maximum Percentage',
   },
   {
      field: 'lastTimeOfDay',
      headerName: 'LAST TOD',
      headerTooltip: 'Last Time Of Day',
   },
   {
      field: 'elapsedPeriod',
      headerName: 'SUB EL TIME P',
      headerTooltip: 'Substitute Elapsed Period',
   },
   {
      field: 'unit2',
      headerName: 'SUB EL TIME U',
      headerTooltip: 'Substitute Elapsed Unit',
   },
   {
      field: 'lastTicketingTimeOfDay',
      headerName: 'SUB TKT TOD',
      headerTooltip: 'Sub Ticketing Time of Day',
   },
   {
      field: 'period',
      headerName: 'SUB EL P',
      headerTooltip: 'Sub Elapsed Period',
   },
   {
      field: 'unit3',
      headerName: 'SUB EL U',
      headerTooltip: 'Sub Unit',
   },
   {
      field: 'imm2',
      headerName: 'SUB TKT IMM',
      headerTooltip: 'Sub Ticketed Immediately',
   },
   {
      field: 'minNumberOfSectors',
      headerName: 'MIN NO SEC',
      headerTooltip: 'Min no of Sectors',
   },
   {
      field: 'outbound',
      headerName: 'OUT',
      headerTooltip: 'Outbound Transfers',
   },
   {
      field: 'inbound',
      headerName: 'IN',
      headerTooltip: 'Inbound Transfers',
   },
   {
      field: 'inboundOrOutbound',
      headerName: 'OUT/IN',
      headerTooltip: 'Either In or Out',
   },
   {
      field: 'timeFrameCode',
      headerName: 'TIME APP',
      headerTooltip: 'Time Applicable',
   },
   {
      field: 'waiverCode',
      headerName: 'WAV CODE',
      headerTooltip: 'Waiver Code',
   },
   {
      field: 'permitCode',
      headerName: 'PERM CODE',
      headerTooltip: 'Permitted Code',
   },
   {
      field: 'sameCode',
      headerName: 'SAME CXR CODE',
      headerTooltip: 'Same Carrier code',
   },
   {
      field: 'inboundOrOutboundOrChanged',
      headerName: 'OUT/IN/CHANGE',
      headerTooltip: 'Inbound/Outbound or Changed',
   },
   {
      field: 'additionalAmount1',
      headerName: 'ADD AMT 1',
      headerTooltip: 'Additional Amount 1',
   },
   {
      field: 'currencyCode1',
      headerName: 'CURR 1',
      headerTooltip: 'Currency 1 Code',
   },
   {
      field: 'decimalPlace1',
      headerName: 'DECIMAL 1',
      headerTooltip: 'Decimal 1',
   },
   {
      field: 'additionalAmount2',
      headerName: 'ADD AMT 2',
      headerTooltip: 'Additional Amount 2',
   },
   {
      field: 'currencyCode2',
      headerName: 'CURR 2',
      headerTooltip: 'Currency 2 Code',
   },
   {
      field: 'decimalPlace2',
      headerName: 'DECIMAL 2',
      headerTooltip: 'Decimal 2',
   },
   {
      field: 'minNumberOfPassengers',
      headerName: 'MIN NUM PASS',
      headerTooltip: 'Minimum Number of Passenger',
   },
   {
      field: 'returnCode',
      headerName: 'RETURN',
      headerTooltip: 'Return Code',
   },
   {
      field: 'minNumberOfTourParticipants',
      headerName: 'MIN TOUR PASS',
      headerTooltip: 'Min no of Tour Participants',
   },
   {
      field: 'maxNumberOfTourParticipants',
      headerName: 'MAX TOUR PASS',
      headerTooltip: 'Max no of Tour Participants',
   },
   {
      field: 'numberOfTourConductors',
      headerName: 'NO TOUR COND',
      headerTooltip: 'Number of Tour Conductors',
   },
   {
      field: 'numberOfPayingPassengers',
      headerName: 'NO PAY PASS',
      headerTooltip: 'Number of Paying Passenger',
   },
   {
      field: 'maxNumberOfTourConductors',
      headerName: 'MAX TOUR COND',
      headerTooltip: 'Max no if Tour Conductors',
   },
   {
      field: 'minAgeOfTourConductor',
      headerName: 'MIN AGE',
      headerTooltip: 'Minimum Age',
   },
   {
      field: 'tvlCode',
      headerName: 'TVL CODE',
      headerTooltip: 'Travel Code',
   },
   {
      field: 'diff',
      headerName: 'DIFF GRP',
      headerTooltip: 'Different Groups',
   },
   {
      field: 'writ',
      headerName: 'WRT APP',
      headerTooltip: 'Written Application',
   },
   {
      field: 'writ',
      headerName: 'WRT APP',
      headerTooltip: 'Written Application',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'andTable995Id',
      headerName: 'AND995ID',
      headerTooltip: 'And GEO 995 Id',
   },
   {
      field: 'betweenTable995Id',
      headerName: 'BET995ID',
      headerTooltip: 'Between GEO 995 Id',
   },
   {
      field: 'geographic995Id',
      headerName: 'GEO995ID',
      headerTooltip: 'GEO 995 Id',
   },
   {
      field: 'groupAndTable995Id',
      headerName: 'GR AND995ID',
      headerTooltip: 'Group And GEO 995 Id',
   },
   {
      field: 'groupBetweenTable995Id',
      headerName: 'GR BET995ID',
      headerTooltip: 'Group Between GEO 995 Id',
   },
   {
      field: 'groupTourAndTable995Id',
      headerName: 'GR TO AND995ID',
      headerTooltip: 'Group Tour And GEO 995 Id',
   },
   {
      field: 'groupTourBetweenTable995Id',
      headerName: 'GR TO BET995ID',
      headerTooltip: 'Group Tour Between GEO 995 Id',
   },
   {
      field: 'individualAndTable995Id',
      headerName: 'IND AND995ID',
      headerTooltip: 'Individual And GEO 995 Id',
   },
   {
      field: 'individualBetweenTable995Id',
      headerName: 'IND BET995ID',
      headerTooltip: 'Individual Between GEO 995 Id',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'transmissionDateTime',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
   },
];
export const CATEGORY_27_TABLE_HEADERS = [
   {
      field: 'tourTypeCode',
      headerName: 'TOUR TYPE',
      headerTooltip: 'Tour Type',
   },
   {
      field: 'tourNumber',
      headerName: 'TOUR NO',
      headerTooltip: 'Tour Number',
   },
   {
      field: 'carrierCode',
      headerName: 'CXR CODE',
      headerTooltip: 'Carrier Code',
   },
   {
      field: 'numNights',
      headerName: 'NO OF NIGHTS',
      headerTooltip: 'Number of Nights',
   },
   {
      field: 'minAppl1Code',
      headerName: 'MIN AMT 1 APP',
      headerTooltip: 'Min Amount 1 Application',
   },
   {
      field: 'minAmount1',
      headerName: 'MIN AMT 1',
      headerTooltip: 'Min Amount 1',
   },
   {
      field: 'additionalAppl1Code',
      headerName: 'ADD 1 APP',
      headerTooltip: 'Additional Night 1 App',
   },
   {
      field: 'additionalAmount1',
      headerName: 'ADD 1 AMT',
      headerTooltip: 'Additional Amount 1',
   },
   {
      field: 'currency1Code',
      headerName: 'CURR 1',
      headerTooltip: 'Currency 1 Code',
   },
   {
      field: 'decimals1Number',
      headerName: 'DECIMAL 1',
      headerTooltip: 'Decimal 1',
   },
   {
      field: 'minAppl2Code',
      headerName: 'MIN AMT 2 APP',
      headerTooltip: 'Min Amount 2 Application',
   },
   {
      field: 'minAmount2',
      headerName: 'MIN AMT 2',
      headerTooltip: 'Min Amount 2',
   },
   {
      field: 'additionalAppl2Code',
      headerName: 'ADD 2 APP',
      headerTooltip: 'Additional Night 2 App',
   },
   {
      field: 'additionalAmount2',
      headerName: 'ADD 2 AMT',
      headerTooltip: 'Additional Amount 2',
   },
   {
      field: 'currency2Code',
      headerName: 'CURR 2',
      headerTooltip: 'Currency 2 Code',
   },
   {
      field: 'decimals2Number',
      headerName: 'DECIMAL 2',
      headerTooltip: 'Decimal 2',
   },
   {
      field: 'minimumPercent',
      headerName: 'MIN PERCENT',
      headerTooltip: 'Minimum Percent',
   },
   {
      field: 'priceMinimum1Amount',
      headerName: 'MIN TOUR AMT 1',
      headerTooltip: 'Minimum Tour Price 1',
   },
   {
      field: 'priceCurrency1Code',
      headerName: 'CURR 1',
      headerTooltip: 'Currency 1 Code',
   },
   {
      field: 'priceDecimals1Number',
      headerName: 'DECIMAL 1',
      headerTooltip: 'Decimal 1',
   },
   {
      field: 'priceMinimum2Amount',
      headerName: 'MIN TOUR AMT 2',
      headerTooltip: 'Minimum Tour Price 2',
   },
   {
      field: 'priceCurrency2Code',
      headerName: 'CURR 2',
      headerTooltip: 'Currency 2 Code',
   },
   {
      field: 'priceDecimals2Number',
      headerName: 'DECIMAL 2',
      headerTooltip: 'Decimal 2',
   },
   {
      field: 'priceApplCode',
      headerName: 'TOUR APP CODE',
      headerTooltip: 'Tour Price App Code',
   },
   {
      field: 'passengerTypeCode',
      headerName: 'PTC',
      headerTooltip: 'Passenger Type Code',
   },
   {
      field: 'minimumAge',
      headerName: 'MIN AGE',
      headerTooltip: 'Minimum Age',
   },
   {
      field: 'maximumAge',
      headerName: 'MAX AGE',
      headerTooltip: 'Maximum Age',
   },
   {
      field: 'nonRefundableInd',
      headerName: 'NON REF',
      headerTooltip: 'Non Refundable Ind',
   },
   {
      field: 'waiverApplicationCode',
      headerName: 'WAV APP',
      headerTooltip: 'Waiver App Code',
   },
   {
      field: 'passengerDeathInd',
      headerName: 'DEATH IND',
      headerTooltip: 'Death Ind',
   },
   {
      field: 'passengerIllInd',
      headerName: 'ILL IND',
      headerTooltip: 'Illness Ind',
   },
   {
      field: 'scheduleChangeInd',
      headerName: 'SCH CH IND',
      headerTooltip: 'Schedule Change Ind',
   },
   {
      field: 'ticketUpgradeInd',
      headerName: 'TKT UG IND',
      headerTooltip: 'Ticket Upgrade Ind',
   },
   {
      field: 'documentDenialInd',
      headerName: 'DOC DEN IND',
      headerTooltip: 'Document denial Ind',
   },
   {
      field: 'juryDutyInd',
      headerName: 'JURY IND',
      headerTooltip: 'Jury Duty Ind',
   },
   {
      field: 'militaryOrdersInd',
      headerName: 'MIL IND',
      headerTooltip: 'Military Orders Ind',
   },
   {
      field: 'fareIncreaseInd',
      headerName: 'FARE INC IND',
      headerTooltip: 'Fare Increase Ind',
   },
   {
      field: 'paymentReceivedInd',
      headerName: 'PAY REC IND',
      headerTooltip: 'Payment Received Ind',
   },
   {
      field: 'numberOfSegments',
      headerName: 'NO OF SEG',
      headerTooltip: 'No Of Segments',
   },
   {
      field: 'groundCruiseRequirementsMinimumGroundAmount',
      headerName: 'MIN GR AMT',
      headerTooltip: 'Minimum Ground Amount',
   },
   {
      field: 'groundCruiseRequirementsCurrencyCode',
      headerName: 'GR CURR',
      headerTooltip: 'Ground Currency Code',
   },
   {
      field: 'groundCruiseRequirementsDecimalPlaces',
      headerName: 'GR DECIMAL',
      headerTooltip: 'Ground Decimal',
   },
   {
      field: 'groundCruiseRequirementsDayTotalIndicator',
      headerName: 'GR APP',
      headerTooltip: 'Minimum Ground Application',
   },
   {
      field: 'groundCruiseRequirementsTransferNumber',
      headerName: 'MIN TRANSFER',
      headerTooltip: 'Minimum Transfer Number',
   },
   {
      field: 'groundCruiseRequirementsMinimumCarRentalDays',
      headerName: 'CAR REN DAY',
      headerTooltip: 'Car Rental Days',
   },
   {
      field: 'groundCruiseRequirementsMinimumDaysAtResort',
      headerName: 'RESORT DAY',
      headerTooltip: 'Days at Resort',
   },
   {
      field: 'groundCruiseRequirementsMinimumDaysOnShip',
      headerName: 'SHIP DAY',
      headerTooltip: 'Days on Ship',
   },
   {
      field: 'groundCruiseRequirementsOtherMinimumDays',
      headerName: 'OTH GR DAY',
      headerTooltip: 'Other Ground Days',
   },
   {
      field: 'groundCruiseRequirementsMaximumConsecutiveFreeDays',
      headerName: 'FREE DAYS',
      headerTooltip: 'Consecutive Free Days',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'transmissionDateTime',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
   },
];
export const CATEGORY_35_TABLE_HEADERS = [
   {
      field: 'security983Id',
      headerName: 'SEC 983 ID',
      headerTooltip: 'Security Table 983 Id',
   },
   {
      field: 'passengerTypeCode',
      headerName: 'PTC',
      headerTooltip: 'Passenger Type Code',
   },
   {
      field: 'fareCreator979Id',
      headerName: 'FARE 979 ID',
      headerTooltip: 'Fare Creator 979 Id',
   },
   {
      field: 'methodTypeCode',
      headerName: 'METHOD TYPE',
      headerTooltip: 'Method Type Code',
   },
   {
      field: 'netGrossInd',
      headerName: 'NET/GROSS',
      headerTooltip: 'Net Gross Ind',
   },
   {
      field: 'commissionPercent',
      headerName: 'COMM PERCENT',
      headerTooltip: 'Commission Percent',
   },
   {
      field: 'commission1Amount',
      headerName: 'COMM 1 AMT',
      headerTooltip: 'Commission 1 Amount',
   },
   {
      field: 'currency1Code',
      headerName: 'CURR 1',
      headerTooltip: 'Currency 1 Code',
   },
   {
      field: 'decimals1Number',
      headerName: 'DECIMAL 1',
      headerTooltip: 'Decimal 1',
   },
   {
      field: 'commission2Amount',
      headerName: 'COMM 2 AMT',
      headerTooltip: 'Commission 2 Amount',
   },
   {
      field: 'currency2Code',
      headerName: 'CURR 2',
      headerTooltip: 'Currency 2 Code',
   },
   {
      field: 'decimals2Number',
      headerName: 'DECIMAL 2',
      headerTooltip: 'Decimal 2',
   },
   {
      field: 'upgradeInd',
      headerName: 'UG IND',
      headerTooltip: 'Upgrade Ind',
   },
   {
      field: 'baggageNumber',
      headerName: 'BAG NO',
      headerTooltip: 'Baggage Number',
   },
   {
      field: 'pieceKilogramInd',
      headerName: 'BAG NO APP',
      headerTooltip: 'Baggage No Application',
   },
   {
      field: 'ticketingInd',
      headerName: 'TKT IND',
      headerTooltip: 'Ticketing Ind',
   },
   {
      field: 'notPermittedInd',
      headerName: 'NOT PERM IND',
      headerTooltip: 'Not Permitted Ind',
   },
   {
      field: 'ticketCarrierCode',
      headerName: 'TKT CXR CODE',
      headerTooltip: 'Ticket Carrier Code',
   },
   {
      field: 'numberOfSegment',
      headerName: 'NO OF SEGS',
      headerTooltip: 'No of Segments',
   },
   {
      field: 'ticketingSegmentsCouponCode',
      headerName: 'COUPON CODE',
      headerTooltip: 'Coupon Code',
   },
   {
      field: 'ticketingSegmentsType',
      headerName: 'TOUR CODE',
      headerTooltip: 'Tour Code Type',
   },
   {
      field: 'ticketingSegmentsTourBoxCode',
      headerName: 'TOUR BOX',
      headerTooltip: 'Tour Box Code',
   },
   {
      field: 'ticketingSegmentsTicketDesignator',
      headerName: 'TKT DESG',
      headerTooltip: 'Ticket Designator',
   },
   {
      field: 'ticketingSegmentsTicketFareData',
      headerName: 'TKT FARE DATA',
      headerTooltip: 'Ticketed Fare Data',
   },
   {
      field: 'ticketingSegmentsOwrtInd',
      headerName: 'OWRT IND',
      headerTooltip: 'OW/RT Ind',
   },
   {
      field: 'ticketingSegmentsGlobalInd',
      headerName: 'GLOBAL IND',
      headerTooltip: 'Global Ind',
   },
   {
      field: 'ticketingSegmentsRuleTariffNumber',
      headerName: 'RTN',
      headerTooltip: 'Rule Tariff Number',
   },
   {
      field: 'ticketingSegmentsCarrierCode',
      headerName: 'CXR CODE',
      headerTooltip: 'Carrier Code',
   },
   {
      field: 'ticketingSegmentsRuleNumber',
      headerName: 'RULE NO',
      headerTooltip: 'Rule Number',
   },
   {
      field: 'ticketingSegmentsFareClassCode',
      headerName: 'FCC',
      headerTooltip: 'Fare Class Code',
   },
   {
      field: 'ticketingSegmentsFareTypeCode',
      headerName: 'FTC',
      headerTooltip: 'Fare Type Code',
   },
   {
      field: 'ticketingSegmentsSeasonTypeCode',
      headerName: 'STC',
      headerTooltip: 'Season Type Code',
   },
   {
      field: 'ticketingSegmentsDayOfWeekType',
      headerName: 'DOW TC',
      headerTooltip: 'Day Of Week Type Code',
   },
   {
      field: 'ticketingSegmentsBetweenCityCode',
      headerName: 'BET CITY CODE',
      headerTooltip: 'Between City Code',
   },
   {
      field: 'ticketingSegmentsAndCityCode',
      headerName: 'AND CITY CODE',
      headerTooltip: 'And City Code',
   },
   {
      field: 'ticketingSegmentsFareBox',
      headerName: 'FARE BOX TXT',
      headerTooltip: 'Fare Box Text',
   },
   {
      field: 'ticketingSegmentsAmount',
      headerName: 'FARE BOX AMT',
      headerTooltip: 'Fare Box Amount',
   },
   {
      field: 'ticketingSegmentsCurrencyCode',
      headerName: 'FARE BOX CURR',
      headerTooltip: 'Fare Box Currency',
   },
   {
      field: 'ticketingSegmentsDecimalPlace',
      headerName: 'FARE BOX DEC',
      headerTooltip: 'Fare Box Decimal',
   },
   {
      field: 'dateOverride994Id',
      headerName: 'OVRD 994',
      headerTooltip: 'Override 994 Id',
      cellStyle: { textAlign: 'right' },
   },
   {
      field: 'travelEffectiveDate',
      headerName: 'TVLEFF 994',
      headerTooltip: 'Override Travel Eff Date',
   },
   {
      field: 'travelDiscontinueDate',
      headerName: 'TVLDIS 994',
      headerTooltip: 'Override Travel Disc Date',
   },
   {
      field: 'reservationEffectiveDate',
      headerName: 'RESEFF 994',
      headerTooltip: 'Override Reser Eff Date'
   },
   {
      field: 'reservationDiscontinueDate',
      headerName: 'RESDISC 994',
      headerTooltip: 'Override Reser Disc Date',
   },
   {
      field: 'text996Id',
      headerName: 'TEXT 996',
      headerTooltip: 'Text 996 Id',
   },
   {
      field: 'text996String',
      headerName: 'TEXT',
      headerTooltip: 'Text 996',
      tooltipField: 'text996String',
      maxWidth: 220,
   },
   {
      field: 'unavailableTag',
      headerName: 'UVD',
      headerTooltip: 'Unavailable Tag',
   },
   {
      field: 'transmissionDateTime',
      headerName: 'REC DT',
      headerTooltip: 'Received Date',
   },
];
